/* AUTO-GENERATED - COMPILED FROM TYPESCRIPT, DO NOT EDIT DIRECTLY */
const CountdownEventName = {
  Tick: "zyg-countdown:tick",
  Expired: "zyg-countdown:expired"
};
const CountdownUnit = {
  Days: "days",
  Hours: "hours",
  Minutes: "minutes",
  Seconds: "seconds"
};
const CountdownUnitDataAttr = {
  [CountdownUnit.Days]: "data-days",
  [CountdownUnit.Hours]: "data-hours",
  [CountdownUnit.Minutes]: "data-minutes",
  [CountdownUnit.Seconds]: "data-seconds"
};
const COUNTDOWN_FLIP_PHASE_ATTR = "data-flip-phase";
const CountdownFlipPhaseValue = {
  A: "a",
  B: "b"
};
const COUNTDOWN_EXPIRED_HIDDEN_CLASS = "zyg-new-countdown--expired-hidden";
const CountdownRootAttr = {
  EndDate: "end-date",
  RestartOnRefresh: "restart-on-refresh",
  DigitStyle: "digit-style",
  ExpirationBehavior: "expiration-behavior"
};
const COUNTDOWN_TICK_INTERVAL_MS = 1e3;
const COUNTDOWN_UNITS = Object.values(CountdownUnit);
const SECONDS_PER_DAY = 86400;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;
const MS_PER_SECOND = 1e3;
const MS_PER_DAY = 864e5;
const PAD_LENGTH = 2;
const PAD_CHARACTER = "0";
function decomposeCountdownMs(milliseconds) {
  const totalSeconds = Number.isFinite(milliseconds) ? Math.max(0, Math.floor(milliseconds / MS_PER_SECOND)) : 0;
  return {
    days: Math.floor(totalSeconds / SECONDS_PER_DAY),
    hours: Math.floor(totalSeconds % SECONDS_PER_DAY / SECONDS_PER_HOUR),
    minutes: Math.floor(totalSeconds % SECONDS_PER_HOUR / SECONDS_PER_MINUTE),
    seconds: totalSeconds % SECONDS_PER_MINUTE,
    totalSeconds
  };
}
const ZERO_COUNTDOWN_TIME = decomposeCountdownMs(0);
function padCountdownValue(value) {
  return String(value).padStart(PAD_LENGTH, PAD_CHARACTER);
}
function nextCountdownFlipPhase(previous) {
  return previous === CountdownFlipPhaseValue.A ? CountdownFlipPhaseValue.B : CountdownFlipPhaseValue.A;
}
function resolveCountdownEndDateForCurrentLoad(endDate, restartOnRefresh, now) {
  const endMs = endDate.getTime();
  const nowMs = now.getTime();
  if (Number.isNaN(endMs) || !restartOnRefresh || endMs > nowMs) {
    return endDate;
  }
  const resolvedEndDate = new Date(endMs);
  resolvedEndDate.setDate(
    resolvedEndDate.getDate() + Math.floor((nowMs - endMs) / MS_PER_DAY) + 1
  );
  const resolvedMs = resolvedEndDate.getTime();
  return resolvedMs > nowMs ? resolvedEndDate : new Date(resolvedMs + MS_PER_DAY);
}
function startCountdownTicker(endDate, handlers) {
  let intervalId;
  const stop = () => {
    if (intervalId !== void 0) {
      clearInterval(intervalId);
      intervalId = void 0;
    }
  };
  let expired = false;
  const tick = () => {
    const remainingMs = endDate.getTime() - Date.now();
    if (remainingMs > 0) {
      handlers.onTick(decomposeCountdownMs(remainingMs));
      return;
    }
    stop();
    if (!expired) {
      expired = true;
      handlers.onExpired();
    }
  };
  tick();
  if (!expired) {
    intervalId = setInterval(tick, COUNTDOWN_TICK_INTERVAL_MS);
  }
  return stop;
}
const RADIX_DECIMAL = 10;
const PERCENTAGE_MULTIPLIER = 100;
const PERCENT_UNIT$1 = "%";
const ATTR_ARIA_HIDDEN = "aria-hidden";
const ARIA_HIDDEN_TRUE$1 = "true";
const ARIA_HIDDEN_FALSE$1 = "false";
const ATTR_ARIA_EXPANDED = "aria-expanded";
const ATTR_ARIA_SELECTED$1 = "aria-selected";
const ATTR_ARIA_ACTIVE_DESCENDANT = "aria-activedescendant";
const CSS_PROP_LEFT = "left";
const CSS_PROP_TRANSFORM = "transform";
const CSS_FN_SCALE_X = "scaleX";
const TAG_SPAN = "span";
const cssScaleX = (progress) => `${CSS_FN_SCALE_X}(${progress})`;
const DEFAULT_OPTION_INDEX = 0;
const INDEX_NONE = -1;
const ATTR_BLOCK_ID = "data-zyg-block-id";
const DISPLAY_NONE = "none";
const WINDOW_TARGET_BLANK = "_blank";
const WINDOW_FEATURES_SECURE = "noopener,noreferrer";
const DEFAULT_SCROLL_BEHAVIOR = "smooth";
const CHECKOUT_URL = "/checkout";
const DISCOUNT_URL_TEMPLATE = "/discount/";
const buildDiscountRedirectUrl = (code, redirectTo) => `${DISCOUNT_URL_TEMPLATE}${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectTo)}`;
const EVENT_INPUT = "input";
const EVENT_CLICK$1 = "click";
const EVENT_SCROLL$1 = "scroll";
const EVENT_RESIZE$2 = "resize";
const EVENT_MOUSEENTER = "mouseenter";
const EVENT_MOUSELEAVE = "mouseleave";
const EVENT_MOUSEDOWN = "mousedown";
const EVENT_MOUSEUP = "mouseup";
const EVENT_TOUCHSTART = "touchstart";
const EVENT_TOUCHEND = "touchend";
const EVENT_KEYDOWN$1 = "keydown";
const EVENT_KEYUP = "keyup";
const KEY_ESCAPE = "Escape";
const KEY_ENTER = "Enter";
const KEY_ARROW_DOWN = "ArrowDown";
const KEY_ARROW_UP = "ArrowUp";
const EVENT_POINTERDOWN = "pointerdown";
const EVENT_POINTERMOVE = "pointermove";
const EVENT_POINTERUP = "pointerup";
const EVENT_POINTERCANCEL = "pointercancel";
function isElementVisible(el) {
  for (let node = el; node; node = node.parentElement) {
    if (window.getComputedStyle(node).display === DISPLAY_NONE) {
      return false;
    }
  }
  return true;
}
function Trackable(Base, config) {
  const { category, errorPrefix = category } = config;
  return class TrackableClass extends Base {
    track(action, payload) {
      if (!isElementVisible(this)) {
        return;
      }
      try {
        window.safeTrackEvent?.(category, action, JSON.stringify(payload));
      } catch (error) {
        console.error(`[${errorPrefix}] Failed to track event:`, action, error);
      }
    }
  };
}
class ContentComponent extends HTMLElement {
  #listeners = [];
  connectedCallback() {
    this.setup();
  }
  disconnectedCallback() {
    for (const { target, event, handler, options } of this.#listeners) {
      target.removeEventListener(event, handler, options);
    }
    this.#listeners = [];
    this.teardown();
  }
  setup() {
  }
  teardown() {
  }
  listen(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    this.#listeners.push({ target, event, handler, options });
  }
  emit(name, detail) {
    this.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  }
  query(selector) {
    return this.querySelector(selector);
  }
  queryAll(selector) {
    return Array.from(this.querySelectorAll(selector));
  }
}
function registerElement(name, ctor) {
  if (!customElements.get(name)) {
    customElements.define(name, ctor);
  }
}
const ATTR_TRUE = "true";
const ANALYTICS_CATEGORY$6 = "countdown";
const ANALYTICS_ACTION_START = "countdown_start";
const ANALYTICS_ACTION_EXPIRED = "countdown_expired";
class CountdownElement extends Trackable(ContentComponent, {
  category: ANALYTICS_CATEGORY$6
}) {
  #endDate = null;
  #endDateAttr = "";
  #stopTicker = null;
  #els = { days: null, hours: null, minutes: null, seconds: null };
  setup() {
    this.#endDateAttr = this.getAttribute(CountdownRootAttr.EndDate) || "";
    if (!this.#endDateAttr) {
      return;
    }
    const parsedEndDate = new Date(this.#endDateAttr);
    if (Number.isNaN(parsedEndDate.getTime())) {
      return;
    }
    this.#endDate = resolveCountdownEndDateForCurrentLoad(
      parsedEndDate,
      this.getAttribute(CountdownRootAttr.RestartOnRefresh) === ATTR_TRUE,
      /* @__PURE__ */ new Date()
    );
    this.#els = Object.fromEntries(
      COUNTDOWN_UNITS.map((unit) => [unit, this.query(`[${CountdownUnitDataAttr[unit]}]`)])
    );
    this.#stopTicker = startCountdownTicker(this.#endDate, {
      onTick: (time) => this.#onTick(time),
      onExpired: () => this.#onExpired()
    });
    this.#trackStart();
  }
  teardown() {
    this.#stopTicker?.();
    this.#stopTicker = null;
  }
  /** Writes one unit's padded value. */
  renderUnit(el, value) {
    el.textContent = value;
  }
  /** Runs once when the timer reaches zero. */
  onExpired() {
  }
  #onTick(time) {
    this.#update(time);
    this.emit(CountdownEventName.Tick, {
      ...time,
      endDate: this.#endDateAttr
    });
  }
  #onExpired() {
    this.#update(ZERO_COUNTDOWN_TIME);
    this.emit(CountdownEventName.Expired, {
      endDate: this.#endDateAttr
    });
    this.#trackExpired();
    this.onExpired();
  }
  #update(time) {
    COUNTDOWN_UNITS.forEach((unit) => {
      const el = this.#els[unit];
      if (el) {
        this.renderUnit(el, padCountdownValue(time[unit]));
      }
    });
  }
  #trackStart() {
    const breakdown = this.#endDate ? decomposeCountdownMs(this.#endDate.getTime() - Date.now()) : null;
    this.track(ANALYTICS_ACTION_START, {
      endDate: this.#endDateAttr,
      totalSeconds: breakdown?.totalSeconds ?? 0
    });
  }
  #trackExpired() {
    this.track(ANALYTICS_ACTION_EXPIRED, { endDate: this.#endDateAttr });
  }
}
const ELEMENT_NAME$l = "zyg-countdown-block";
class ZygCountdownBlock extends CountdownElement {
}
registerElement(ELEMENT_NAME$l, ZygCountdownBlock);
const ALLOWED_PROTOCOLS = ["https:"];
const NAVIGATE_ERRORS = {
  INVALID_URL: "Invalid URL:",
  BLOCKED_PROTOCOL: "Blocked navigation to disallowed protocol:",
  BLOCKED_CROSS_ORIGIN: "Blocked cross-origin navigation to:"
};
const isDefined = (value) => value != null;
const isNotEmpty = (value) => {
  return value != null && value.trim() !== "";
};
const navigateToUrl = (url) => {
  try {
    const absoluteUrl = new URL(url, window.location.origin);
    if (!ALLOWED_PROTOCOLS.includes(absoluteUrl.protocol)) {
      console.error(NAVIGATE_ERRORS.BLOCKED_PROTOCOL, url);
      return false;
    }
    if (absoluteUrl.origin !== window.location.origin) {
      console.error(NAVIGATE_ERRORS.BLOCKED_CROSS_ORIGIN, url);
      return false;
    }
    window.location.href = absoluteUrl.href;
    return true;
  } catch {
    console.error(NAVIGATE_ERRORS.INVALID_URL, url);
    return false;
  }
};
const parseIntOrZero = (value) => parseInt(value || "0", 10) || 0;
const boolToString = (value) => value ? "true" : "false";
function debounce(callback, delayMs) {
  let timer;
  const debounced = (...args) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => callback(...args), delayMs);
  };
  debounced.cancel = () => window.clearTimeout(timer);
  return debounced;
}
const ELEMENT_NAME$k = "zyg-quotes-carousel";
const ANALYTICS_CATEGORY$5 = "carousel";
const ANALYTICS_ACTION_NAV = "carousel_nav";
const DIRECTION_LABEL_PREV = "prev";
const DIRECTION_LABEL_NEXT = "next";
const ATTR_AUTOPLAY$1 = "autoplay";
const ATTR_PAUSE_ON_HOVER = "pause-on-hover";
const ATTR_NAV = "data-nav";
const ATTR_TRACK$1 = "data-track";
const ATTR_SLIDE = "data-slide";
const NAV_PREV = "prev";
const NAV_NEXT = "next";
const DIRECTION_PREV = -1;
const DIRECTION_NEXT = 1;
const DEFAULT_AUTOPLAY_MS = 5e3;
const MIN_AUTOPLAY_MS = 1e3;
const CLASS_AT_START = "zyg-quotes-carousel--at-start";
const CLASS_AT_END = "zyg-quotes-carousel--at-end";
const EDGE_THRESHOLD = 2;
const EVENT_CAROUSEL_SCROLL = "zyg-carousel:scroll";
const EVENT_CAROUSEL_NAV = "zyg-carousel:nav";
function parseAutoplayMs(value) {
  if (!value) {
    return DEFAULT_AUTOPLAY_MS;
  }
  const parsed = parseInt(value, RADIX_DECIMAL);
  if (isNaN(parsed) || parsed < MIN_AUTOPLAY_MS) {
    return DEFAULT_AUTOPLAY_MS;
  }
  return parsed;
}
function getEdgeState(el) {
  return {
    atStart: el.scrollLeft <= EDGE_THRESHOLD,
    atEnd: el.scrollLeft + el.clientWidth >= el.scrollWidth - EDGE_THRESHOLD
  };
}
class ZygQuotesCarousel extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY$5 }) {
  #track = null;
  #slides = [];
  #autoplayTimer = null;
  setup() {
    this.#track = this.query(`[${ATTR_TRACK$1}]`);
    this.#slides = this.queryAll(`[${ATTR_SLIDE}]`);
    const prevBtn = this.query(`[${ATTR_NAV}="${NAV_PREV}"]`);
    const nextBtn = this.query(`[${ATTR_NAV}="${NAV_NEXT}"]`);
    if (prevBtn) {
      this.listen(prevBtn, EVENT_CLICK$1, this.#handlePrev);
    }
    if (nextBtn) {
      this.listen(nextBtn, EVENT_CLICK$1, this.#handleNext);
    }
    if (this.#track) {
      this.listen(this.#track, EVENT_SCROLL$1, this.#handleScroll, { passive: true });
    }
    this.#updateEdgeClasses();
    this.#startAutoplay();
    if (this.hasAttribute(ATTR_PAUSE_ON_HOVER)) {
      this.listen(this, EVENT_MOUSEENTER, this.#stopAutoplay);
      this.listen(this, EVENT_MOUSELEAVE, this.#startAutoplay);
    }
  }
  teardown() {
    this.#stopAutoplay();
  }
  #handlePrev = () => {
    this.#scrollByCard(DIRECTION_PREV);
    this.#dispatchNav(DIRECTION_PREV);
    this.track(ANALYTICS_ACTION_NAV, { direction: DIRECTION_LABEL_PREV });
  };
  #handleNext = () => {
    this.#scrollByCard(DIRECTION_NEXT);
    this.#dispatchNav(DIRECTION_NEXT);
    this.track(ANALYTICS_ACTION_NAV, { direction: DIRECTION_LABEL_NEXT });
  };
  #handleScroll = () => {
    this.#updateEdgeClasses();
    this.#dispatchScroll();
  };
  #scrollByCard(direction) {
    if (!isDefined(this.#track) || this.#slides.length === 0) {
      return;
    }
    this.#track.scrollBy({
      left: direction * (this.#slides[0].offsetWidth + this.#getTrackGap()),
      behavior: DEFAULT_SCROLL_BEHAVIOR
    });
  }
  #getTrackGap() {
    if (!this.#track) {
      return 0;
    }
    return parseInt(window.getComputedStyle(this.#track).columnGap || "0", RADIX_DECIMAL) || 0;
  }
  #updateEdgeClasses() {
    if (!this.#track) {
      return;
    }
    const { atStart, atEnd } = getEdgeState(this.#track);
    this.classList.toggle(CLASS_AT_START, atStart);
    this.classList.toggle(CLASS_AT_END, atEnd);
  }
  #startAutoplay = () => {
    if (!this.hasAttribute(ATTR_AUTOPLAY$1) || this.#slides.length <= 1) {
      return;
    }
    this.#stopAutoplay();
    this.#autoplayTimer = setInterval(
      () => {
        if (!isDefined(this.#track)) {
          return;
        }
        if (getEdgeState(this.#track).atEnd) {
          this.#track.scrollTo({ left: 0, behavior: DEFAULT_SCROLL_BEHAVIOR });
        } else {
          this.#scrollByCard(DIRECTION_NEXT);
        }
      },
      parseAutoplayMs(this.getAttribute(ATTR_AUTOPLAY$1))
    );
  };
  #stopAutoplay = () => {
    if (this.#autoplayTimer !== null) {
      clearInterval(this.#autoplayTimer);
      this.#autoplayTimer = null;
    }
  };
  #dispatchScroll() {
    if (!this.#track) {
      return;
    }
    const { scrollLeft, scrollWidth, clientWidth } = this.#track;
    const { atStart, atEnd } = getEdgeState(this.#track);
    this.emit(EVENT_CAROUSEL_SCROLL, { scrollLeft, scrollWidth, clientWidth, atStart, atEnd });
  }
  #dispatchNav(direction) {
    this.emit(EVENT_CAROUSEL_NAV, { direction });
  }
  /** Scroll to next card */
  next() {
    this.#scrollByCard(DIRECTION_NEXT);
    this.#dispatchNav(DIRECTION_NEXT);
  }
  /** Scroll to previous card */
  prev() {
    this.#scrollByCard(DIRECTION_PREV);
    this.#dispatchNav(DIRECTION_PREV);
  }
  /** Whether the track is scrolled to the start */
  get atStart() {
    return this.classList.contains(CLASS_AT_START);
  }
  /** Whether the track is scrolled to the end */
  get atEnd() {
    return this.classList.contains(CLASS_AT_END);
  }
  /** Total number of slides */
  get total() {
    return this.#slides.length;
  }
}
registerElement(ELEMENT_NAME$k, ZygQuotesCarousel);
const ELEMENT_NAME$j = "zyg-content-navigation";
const LAYOUT_BAR = "bar";
const ATTR_LAYOUT = "layout";
const ATTR_STICKY$1 = "sticky";
const ATTR_SCROLL_OFFSET = "data-scroll-offset";
const ATTR_TARGET = "data-target";
const ATTR_NAV_ITEM = "data-nav-item";
const ATTR_LABEL = "data-label";
const CLASS_STICKY = "zyg-navigation--sticky";
const CLASS_ITEM_SELECTED = "zyg-content-navigation__item--selected";
const EVENT_NAVIGATION_SELECT = "zyg-navigation:select";
const ANALYTICS_CATEGORY$4 = "navigation";
const ANALYTICS_ACTION_SELECT$2 = "navigation_select";
const DEFAULT_SCROLL_OFFSET_PX = 80;
const INTERSECTION_THRESHOLD$1 = 0.3;
const SELECTOR_NAV_ITEM = `[${ATTR_NAV_ITEM}]`;
class ZygContentNavigation extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY$4 }) {
  #items = [];
  #observer = null;
  setup() {
    this.#items = this.queryAll(SELECTOR_NAV_ITEM);
    this.#items.forEach((item) => {
      this.listen(item, EVENT_CLICK$1, () => this.#handleItemClick(item));
    });
    if (this.#isSticky()) {
      this.classList.add(CLASS_STICKY);
    }
    this.#observeSections();
  }
  teardown() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
  #handleItemClick(item) {
    const targetId = item.getAttribute(ATTR_TARGET);
    const label = item.getAttribute(ATTR_LABEL) || item.textContent?.trim() || "";
    this.#selectItem(item);
    if (targetId) {
      this.#scrollToTarget(targetId);
    }
    this.emit(EVENT_NAVIGATION_SELECT, {
      target: targetId || "",
      label
    });
    this.track(ANALYTICS_ACTION_SELECT$2, { target: targetId || "", label });
  }
  #selectItem(item) {
    this.#items.forEach((el) => el.classList.remove(CLASS_ITEM_SELECTED));
    item.classList.add(CLASS_ITEM_SELECTED);
  }
  #getScrollOffset() {
    const parsed = parseInt(this.getAttribute(ATTR_SCROLL_OFFSET) || "", RADIX_DECIMAL);
    return Number.isNaN(parsed) ? DEFAULT_SCROLL_OFFSET_PX : parsed;
  }
  #scrollToTarget(targetId) {
    const target = document.getElementById(targetId);
    if (!target) {
      return;
    }
    const top = target.getBoundingClientRect().top + window.scrollY - this.#getScrollOffset();
    window.scrollTo({ top, behavior: DEFAULT_SCROLL_BEHAVIOR });
  }
  #isSticky() {
    return this.hasAttribute(ATTR_STICKY$1) && this.#isBarLayout();
  }
  #isBarLayout() {
    return this.getAttribute(ATTR_LAYOUT) === LAYOUT_BAR;
  }
  #observeSections() {
    const targetIds = this.#items.map((item) => item.getAttribute(ATTR_TARGET)).filter((id) => id !== null);
    if (targetIds.length === 0) {
      return;
    }
    const offset = this.#getScrollOffset();
    this.#observer = new IntersectionObserver(
      (entries) => {
        const intersecting = entries.filter((e) => e.isIntersecting);
        if (intersecting.length === 0) {
          return;
        }
        const topEntry = intersecting.reduce(
          (a, b) => a.boundingClientRect.top < b.boundingClientRect.top ? a : b
        );
        const matchingItem = this.#items.find(
          (item) => item.getAttribute(ATTR_TARGET) === topEntry.target.id
        );
        if (matchingItem) {
          this.#selectItem(matchingItem);
        }
      },
      { threshold: INTERSECTION_THRESHOLD$1, rootMargin: `-${offset}px 0px 0px 0px` }
    );
    targetIds.forEach((id) => {
      const section = document.getElementById(id);
      if (section && this.#observer) {
        this.#observer.observe(section);
      }
    });
  }
  get selectedItem() {
    return this.query(`.${CLASS_ITEM_SELECTED}`) ?? null;
  }
  get selectedLabel() {
    const item = this.selectedItem;
    return item?.getAttribute(ATTR_LABEL) || item?.textContent?.trim() || "";
  }
  get total() {
    return this.#items.length;
  }
}
registerElement(ELEMENT_NAME$j, ZygContentNavigation);
const ATTR_TOGGLE_BUTTON = "data-toggle-button";
const ATTR_TOGGLE_BUTTON_INDEX = "data-toggle-button-index";
const CLASS_TOGGLE_BUTTON_SELECTED = "zyg-toggle-button--selected";
const CLASS_TOGGLE_BUTTON_LABEL = "zyg-toggle-button__label";
const SELECTOR_TOGGLE_BUTTON = `[${ATTR_TOGGLE_BUTTON}]`;
const SELECTOR_TOGGLE_BUTTON_LABEL = `.${CLASS_TOGGLE_BUTTON_LABEL}`;
function selectToggleButton(buttons, activeIndex) {
  buttons.forEach((button, i) => {
    button.classList.toggle(CLASS_TOGGLE_BUTTON_SELECTED, i === activeIndex);
    button.setAttribute("aria-pressed", i === activeIndex ? "true" : "false");
  });
}
function getToggleButtonLabel(button) {
  return button?.querySelector(SELECTOR_TOGGLE_BUTTON_LABEL)?.textContent?.trim() || "";
}
const ELEMENT_NAME$i = "zyg-pills-carousel";
const ATTR_TOGGLE_BUTTON_CONTENT = "data-toggle-button-content";
const SELECTOR_TOGGLE_BUTTON_CONTENT = `template[${ATTR_TOGGLE_BUTTON_CONTENT}]`;
const ATTR_PANEL$1 = "data-panel";
const SELECTOR_PANEL$4 = `[${ATTR_PANEL$1}]`;
const ATTR_TRACK = "data-track";
const SELECTOR_TRACK = `[${ATTR_TRACK}]`;
const ATTR_MEDIA_ITEM = "data-pills-carousel-media-item";
const ATTR_MEDIA_ITEM_INDEX = "data-pills-carousel-media-index";
const SELECTOR_MEDIA_ITEM = `[${ATTR_MEDIA_ITEM}]`;
const ATTR_TEXT_ITEM = "data-pills-carousel-text-item";
const ATTR_TEXT_ITEM_INDEX = "data-pills-carousel-text-index";
const CLASS_TEXT_ITEM = "zyg-pills-carousel__text-item";
const SELECTOR_TEXT_ITEM = `[${ATTR_TEXT_ITEM}]`;
const ATTR_TEXT_ITEMS = "data-pills-carousel-text-items";
const SELECTOR_TEXT_ITEMS = `[${ATTR_TEXT_ITEMS}]`;
const ATTR_TEXT_SOURCE = "data-pills-carousel-text-source";
const SELECTOR_TEXT_SOURCE = `[${ATTR_TEXT_SOURCE}]`;
const EVENT_PILLS_SELECT = "zyg-pills-carousel:select";
const ANALYTICS_CATEGORY$3 = "pills_carousel";
const ANALYTICS_ACTION_SELECT$1 = "pill_select";
const SWIPE_THRESHOLD_PX = 50;
const TAG_DIV = "div";
const INVALID_INDEX_ATTRIBUTE_VALUE = "-1";
const ATTR_TRANSITION_TYPE = "data-transition-type";
const TRANSITION_TYPE_FADE = "fade";
const CLASS_PANEL_ACTIVE = "zyg-pills-carousel__panel--active";
const TRANSLATE_X_PREFIX = "translateX(-";
const TRANSLATE_X_SUFFIX = "%)";
const PERCENT_PER_PANEL = 100;
class ZygPillsCarousel extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY$3 }) {
  #toggleButtons = [];
  #mediaItems = [];
  #textItems = [];
  #panels = [];
  #track = null;
  #activeIndex = 0;
  #dragStartX = null;
  #isFadeTransition = false;
  setup() {
    this.#populateToggleButtonsFromTemplates();
    this.#populateTextItemsFromSources();
    this.#toggleButtons = this.queryAll(SELECTOR_TOGGLE_BUTTON);
    this.#mediaItems = this.queryAll(SELECTOR_MEDIA_ITEM);
    this.#textItems = this.queryAll(SELECTOR_TEXT_ITEM);
    this.#panels = this.queryAll(SELECTOR_PANEL$4);
    this.#track = this.query(SELECTOR_TRACK);
    this.#isFadeTransition = this.getAttribute(ATTR_TRANSITION_TYPE) === TRANSITION_TYPE_FADE;
    this.#toggleButtons.forEach((button) => {
      this.listen(button, EVENT_CLICK$1, () => this.#handleToggleButtonClick(button));
    });
    if (this.#track) {
      this.listen(
        this.#track,
        EVENT_TOUCHSTART,
        ((e) => this.#handleStart(e.touches[0].clientX)),
        { passive: true }
      );
      this.listen(
        this.#track,
        EVENT_TOUCHEND,
        ((e) => this.#handleEnd(e.changedTouches[0].clientX)),
        { passive: true }
      );
      this.listen(this.#track, EVENT_MOUSEDOWN, ((e) => {
        e.preventDefault();
        this.#handleStart(e.clientX);
      }));
      this.listen(this.#track, EVENT_MOUSEUP, ((e) => this.#handleEnd(e.clientX)));
      this.listen(this.#track, EVENT_MOUSELEAVE, () => this.#handleCancel());
    }
    if (this.#toggleButtons.length > 0) {
      this.#activeIndex = 0;
      this.#dragStartX = null;
      selectToggleButton(this.#toggleButtons, 0);
      this.#setShownIndexedItems(0);
      if (this.#isFadeTransition) {
        this.#fadeToPanel(0);
      }
    }
  }
  #populateToggleButtonsFromTemplates() {
    const panels = this.queryAll(SELECTOR_PANEL$4);
    const buttons = this.queryAll(SELECTOR_TOGGLE_BUTTON);
    panels.forEach((panel, index) => {
      const template = panel.querySelector(
        SELECTOR_TOGGLE_BUTTON_CONTENT
      );
      const button = buttons[index];
      if (!template || !button) {
        return;
      }
      button.replaceChildren(template.content.cloneNode(true));
    });
  }
  #populateTextItemsFromSources() {
    const container = this.query(SELECTOR_TEXT_ITEMS);
    if (!container) {
      return;
    }
    container.replaceChildren(
      ...this.queryAll(SELECTOR_PANEL$4).flatMap((panel, index) => {
        const source = panel.querySelector(SELECTOR_TEXT_SOURCE);
        if (!source) {
          return [];
        }
        const item = document.createElement(TAG_DIV);
        item.classList.add(CLASS_TEXT_ITEM);
        item.setAttribute(ATTR_TEXT_ITEM, "");
        item.setAttribute(ATTR_TEXT_ITEM_INDEX, String(index));
        item.hidden = index !== 0;
        item.appendChild(source.cloneNode(true));
        return [item];
      })
    );
  }
  #handleToggleButtonClick(button) {
    this.#goTo(this.#parseIndexAttribute(button, ATTR_TOGGLE_BUTTON_INDEX));
  }
  #goTo(index) {
    if (Number.isNaN(index) || index < 0 || index >= this.#toggleButtons.length) {
      return;
    }
    this.#activeIndex = index;
    selectToggleButton(this.#toggleButtons, index);
    this.#setShownIndexedItems(index);
    this.#slideToPanel(index);
    const label = getToggleButtonLabel(this.#toggleButtons[index]);
    this.emit(EVENT_PILLS_SELECT, { index, label });
    this.track(ANALYTICS_ACTION_SELECT$1, { index, label });
  }
  #slideToPanel(index) {
    if (this.#isFadeTransition) {
      this.#fadeToPanel(index);
      return;
    }
    if (!this.#track) {
      return;
    }
    this.#track.style.transform = `${TRANSLATE_X_PREFIX}${index * PERCENT_PER_PANEL}${TRANSLATE_X_SUFFIX}`;
  }
  #fadeToPanel(index) {
    if (this.#track) {
      this.#track.style.transform = "";
    }
    this.#panels.forEach((panel, panelIndex) => {
      panel.classList.toggle(CLASS_PANEL_ACTIVE, panelIndex === index);
    });
  }
  #setShownIndexedItems(index) {
    [
      { items: this.#mediaItems, indexAttribute: ATTR_MEDIA_ITEM_INDEX },
      { items: this.#textItems, indexAttribute: ATTR_TEXT_ITEM_INDEX }
    ].forEach(({ items, indexAttribute }) => {
      this.#setShownItems(items, indexAttribute, index);
    });
  }
  #setShownItems(items, indexAttribute, index) {
    items.forEach(
      (item) => this.#setShown(item, this.#parseIndexAttribute(item, indexAttribute) === index)
    );
  }
  #parseIndexAttribute(item, indexAttribute) {
    return parseInt(
      item.getAttribute(indexAttribute) ?? INVALID_INDEX_ATTRIBUTE_VALUE,
      RADIX_DECIMAL
    );
  }
  #setShown(item, shown) {
    item.hidden = !shown;
  }
  #handleStart(x) {
    this.#dragStartX = x;
  }
  #handleEnd(x) {
    if (this.#dragStartX === null) {
      return;
    }
    const diff = this.#dragStartX - x;
    if (Math.abs(diff) > SWIPE_THRESHOLD_PX) {
      this.#goTo(diff > 0 ? this.#activeIndex + 1 : this.#activeIndex - 1);
    }
    this.#dragStartX = null;
  }
  #handleCancel() {
    this.#dragStartX = null;
  }
  /** Currently selected toggle button index */
  get selectedIndex() {
    return this.#activeIndex;
  }
  /** Label text of the currently selected toggle button */
  get selectedLabel() {
    return getToggleButtonLabel(this.#toggleButtons[this.#activeIndex]);
  }
  /** Total number of toggle buttons */
  get total() {
    return this.#toggleButtons.length;
  }
}
registerElement(ELEMENT_NAME$i, ZygPillsCarousel);
const ELEMENT_NAME$h = "zyg-collections";
const ATTR_PANEL = "data-collections-panel";
const SELECTOR_PANEL$3 = `[${ATTR_PANEL}]`;
const CLASS_CARD_CONTENT = "zyg-product-item__content";
const SELECTOR_CARD_CONTENT = `.${CLASS_CARD_CONTENT}`;
const ATTR_CARD_ROWS = "data-card-rows";
const CSS_VAR_CARD_ROWS = "--zyg-collections-card-rows";
const EVENT_COLLECTIONS_SELECT = "zyg-collections:select";
const ANALYTICS_CATEGORY$2 = "collections";
const ANALYTICS_ACTION_SELECT = "collection_select";
const URL_PARAM_COLLECTION = "collection";
const ATTR_COLLECTION_HANDLE = "data-collection-handle";
const COLLECTION_URL_PREFIX = "/collections/";
const ATTR_NAVIGATE_TO_COLLECTION = "data-navigate-to-collection";
const PATH_SEGMENT_SEPARATOR = "/";
class ZygCollections extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY$2 }) {
  #toggleButtons = [];
  #panels = [];
  #activeIndex = 0;
  setup() {
    this.#toggleButtons = this.queryAll(SELECTOR_TOGGLE_BUTTON);
    this.#panels = this.queryAll(SELECTOR_PANEL$3);
    this.#toggleButtons.forEach((button) => {
      this.listen(button, EVENT_CLICK$1, () => this.#handleToggleButtonClick(button));
    });
    if (this.#toggleButtons.length > 0) {
      const urlIndex = this.#indexFromUrl();
      const initialIndex = urlIndex >= 0 ? urlIndex : DEFAULT_OPTION_INDEX;
      this.#activeIndex = initialIndex;
      selectToggleButton(this.#toggleButtons, initialIndex);
      this.#showPanel(initialIndex);
    }
    this.#applyCardRowSpan();
  }
  #applyCardRowSpan() {
    const rows = this.query(SELECTOR_CARD_CONTENT)?.children.length ?? 0;
    if (rows === 0) {
      return;
    }
    this.style.setProperty(CSS_VAR_CARD_ROWS, String(rows));
    this.setAttribute(ATTR_CARD_ROWS, String(rows));
  }
  #handleToggleButtonClick(button) {
    const index = parseInt(
      button.getAttribute(ATTR_TOGGLE_BUTTON_INDEX) || String(DEFAULT_OPTION_INDEX),
      RADIX_DECIMAL
    );
    if (Number.isNaN(index)) {
      return;
    }
    if (this.hasAttribute(ATTR_NAVIGATE_TO_COLLECTION)) {
      this.#navigateToCollectionPage(button, index);
      return;
    }
    this.#goTo(index);
  }
  #navigateToCollectionPage(button, index) {
    const handle = button.getAttribute(ATTR_COLLECTION_HANDLE);
    if (!handle) {
      this.#goTo(index);
      return;
    }
    this.#announceSelection(index, button);
    window.location.assign(`${COLLECTION_URL_PREFIX}${handle}`);
  }
  #goTo(index) {
    if (index < 0 || index >= this.#toggleButtons.length) {
      return;
    }
    this.#activeIndex = index;
    selectToggleButton(this.#toggleButtons, index);
    this.#showPanel(index);
    this.#syncUrlFromIndex(index);
    this.#announceSelection(index, this.#toggleButtons[index]);
  }
  #announceSelection(index, button) {
    const label = getToggleButtonLabel(button);
    this.emit(EVENT_COLLECTIONS_SELECT, { index, label });
    this.track(ANALYTICS_ACTION_SELECT, { index, label });
  }
  #showPanel(index) {
    this.#panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
  #indexFromUrl() {
    const queryHandle = new URLSearchParams(window.location.search).get(URL_PARAM_COLLECTION);
    const handle = queryHandle || this.#handleFromPath();
    if (!handle) {
      return -1;
    }
    return this.#toggleButtons.findIndex(
      (button) => button.getAttribute(ATTR_COLLECTION_HANDLE) === handle
    );
  }
  #handleFromPath() {
    const marker = window.location.pathname.indexOf(COLLECTION_URL_PREFIX);
    if (marker < 0) {
      return "";
    }
    return window.location.pathname.slice(marker + COLLECTION_URL_PREFIX.length).split(PATH_SEGMENT_SEPARATOR)[0];
  }
  #syncUrlFromIndex(index) {
    const handle = this.#toggleButtons[index].getAttribute(ATTR_COLLECTION_HANDLE);
    if (!handle) {
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set(URL_PARAM_COLLECTION, handle);
    window.history.replaceState(window.history.state, "", url);
  }
  get selectedIndex() {
    return this.#activeIndex;
  }
  get selectedLabel() {
    if (this.#toggleButtons.length === 0) {
      return "";
    }
    return getToggleButtonLabel(this.#toggleButtons[this.#activeIndex]);
  }
  get total() {
    return this.#toggleButtons.length;
  }
}
registerElement(ELEMENT_NAME$h, ZygCollections);
const ELEMENT_NAME$g = "zyg-hero";
const SELECTOR_AUTOPLAY_VIDEO = "video[autoplay]";
const SELECTOR_PLAY_BUTTON = "[data-zyg-hero-play]";
const SELECTOR_VIDEO$2 = "video";
const CLASS_PLAY_BUTTON_HIDDEN = "zyg-hero__play-button--hidden";
class ZygHero extends ContentComponent {
  setup() {
    this.#playAutoplayVideos();
    this.queryAll(SELECTOR_PLAY_BUTTON).forEach((button) => {
      this.listen(button, EVENT_CLICK$1, () => {
        this.#playFirstVisibleVideo(button);
      });
    });
  }
  #playAutoplayVideos() {
    this.queryAll(SELECTOR_AUTOPLAY_VIDEO).forEach((video) => {
      if (isElementVisible(video)) {
        this.#playAutoplayVideo(video);
      }
    });
  }
  #playAutoplayVideo(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    this.#play(video);
  }
  #playFirstVisibleVideo(button) {
    const video = this.queryAll(SELECTOR_VIDEO$2).find(isElementVisible);
    if (!video) {
      return;
    }
    button.classList.add(CLASS_PLAY_BUTTON_HIDDEN);
    this.#play(video);
  }
  #play(video, onRejected) {
    const promise = video.play();
    if (promise && typeof promise.catch === "function") {
      promise.catch(() => onRejected?.());
    }
  }
}
registerElement(ELEMENT_NAME$g, ZygHero);
const ELEMENT_NAME$f = "zyg-media";
const SELECTOR_POSTER = ".zyg-media__poster";
const SELECTOR_VIDEO$1 = ".zyg-media__video";
const SELECTOR_NATIVE_VIDEO = "video";
const SELECTOR_IFRAME = "iframe";
const CLASS_VIDEO_HIDDEN = "zyg-media__video--hidden";
const AUTOPLAY_PARAM = "autoplay";
const AUTOPLAY_ON = "1";
class ZygMedia extends ContentComponent {
  setup() {
    const poster = this.query(SELECTOR_POSTER);
    if (!poster) {
      return;
    }
    this.listen(poster, EVENT_CLICK$1, () => {
      this.#playFromPoster(poster);
    });
  }
  #playFromPoster(poster) {
    const media = this.query(SELECTOR_VIDEO$1);
    if (!media) {
      return;
    }
    poster.remove();
    media.classList.remove(CLASS_VIDEO_HIDDEN);
    const video = media.querySelector(SELECTOR_NATIVE_VIDEO);
    if (video) {
      video.controls = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => void 0);
      }
    }
    const iframe = media.querySelector(SELECTOR_IFRAME);
    if (!iframe?.src) {
      return;
    }
    const url = new URL(iframe.src, window.location.origin);
    url.searchParams.set(AUTOPLAY_PARAM, AUTOPLAY_ON);
    iframe.src = url.toString();
  }
}
registerElement(ELEMENT_NAME$f, ZygMedia);
const ELEMENT_NAME$e = "zyg-media-review";
const SELECTOR_VIDEO = "video";
const SELECTOR_SOUND_BUTTON = "[data-zyg-media-review-sound]";
const CLASS_SOUND_UNMUTED = "zyg-media-review__sound--unmuted";
const ATTR_AUTOPLAY = "data-autoplay";
const ATTR_LABEL_UNMUTE = "data-label-unmute";
const ATTR_LABEL_MUTE = "data-label-mute";
const ATTR_ARIA_PRESSED = "aria-pressed";
const ATTR_ARIA_LABEL = "aria-label";
const EVENT_MEDIA_REVIEW_UNMUTED = "zyg-media-review:unmuted";
const EVENT_ENDED$1 = "ended";
const EVENT_VISIBILITY_CHANGE = "visibilitychange";
const VISIBILITY_HIDDEN = "hidden";
const REDUCED_MOTION_QUERY$2 = "(prefers-reduced-motion: reduce)";
const CURRENT_TIME_START = 0;
const VOLUME_FULL = 1;
const HAVE_METADATA = 1;
const INTERSECTION_THRESHOLD = 0.5;
class ZygMediaReview extends ContentComponent {
  #video = null;
  #button = null;
  #observer = null;
  #autoplay = false;
  setup() {
    this.#video = this.query(SELECTOR_VIDEO);
    this.#button = this.query(SELECTOR_SOUND_BUTTON);
    if (!this.#video || !this.#button) {
      return;
    }
    this.#autoplay = this.getAttribute(ATTR_AUTOPLAY) === "true";
    this.#video.playsInline = true;
    if (this.#autoplay) {
      this.#video.muted = true;
      this.#video.defaultMuted = true;
    }
    if (window.matchMedia(REDUCED_MOTION_QUERY$2).matches) {
      this.#video.pause();
    }
    this.listen(this.#button, EVENT_CLICK$1, this.#onSoundClick);
    this.listen(this.#video, EVENT_ENDED$1, this.#onEnded);
    this.listen(document, EVENT_MEDIA_REVIEW_UNMUTED, this.#onPeerUnmuted);
    this.listen(document, EVENT_VISIBILITY_CHANGE, this.#onVisibilityChange);
    this.#observeViewport();
    this.#syncButton();
  }
  teardown() {
    this.#observer?.disconnect();
    this.#observer = null;
    this.#video = null;
    this.#button = null;
  }
  #onSoundClick = () => {
    if (this.#isAudible()) {
      this.#silence();
      return;
    }
    this.#playWithAudio();
    this.emit(EVENT_MEDIA_REVIEW_UNMUTED, void 0);
  };
  #onEnded = () => {
    this.#silence();
  };
  #onPeerUnmuted = (event) => {
    if (event.target === this) {
      return;
    }
    this.#silence();
  };
  #onVisibilityChange = () => {
    if (document.visibilityState === VISIBILITY_HIDDEN) {
      this.#silence();
    }
  };
  #observeViewport() {
    if (typeof IntersectionObserver === "undefined") {
      return;
    }
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => !entry.isIntersecting)) {
          this.#silence();
        }
      },
      { threshold: INTERSECTION_THRESHOLD }
    );
    this.#observer.observe(this);
  }
  #playWithAudio() {
    const video = this.#video;
    if (!video) {
      return;
    }
    video.muted = false;
    video.defaultMuted = false;
    video.volume = VOLUME_FULL;
    video.loop = false;
    if (video.readyState >= HAVE_METADATA) {
      video.currentTime = CURRENT_TIME_START;
    }
    this.#play(video);
    this.#syncButton();
  }
  #silence() {
    const video = this.#video;
    if (!video) {
      return;
    }
    video.muted = true;
    video.defaultMuted = true;
    video.loop = this.#autoplay;
    if (this.#autoplay) {
      this.#play(video);
    } else {
      video.pause();
    }
    this.#syncButton();
  }
  #play(video) {
    const promise = video.play();
    if (promise && typeof promise.catch === "function") {
      promise.catch(() => void 0);
    }
  }
  #isAudible() {
    const video = this.#video;
    return Boolean(video && !video.muted && video.volume > 0 && !video.paused);
  }
  #syncButton() {
    const button = this.#button;
    if (!button) {
      return;
    }
    const audible = this.#isAudible();
    button.classList.toggle(CLASS_SOUND_UNMUTED, audible);
    button.setAttribute(ATTR_ARIA_PRESSED, String(audible));
    const label = audible ? button.getAttribute(ATTR_LABEL_MUTE) : button.getAttribute(ATTR_LABEL_UNMUTE);
    if (label) {
      button.setAttribute(ATTR_ARIA_LABEL, label);
    }
  }
}
registerElement(ELEMENT_NAME$e, ZygMediaReview);
const Orientation = {
  Vertical: "vertical"
};
function clamp$1(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}
const PERCENT_UNIT = "%";
function percent(value) {
  return `${value}${PERCENT_UNIT}`;
}
const SliderValue = {
  Minimum: 0,
  Maximum: 100,
  Default: 50,
  Precision: 2,
  Step: 2,
  PageStep: 10
};
const SliderKey = {
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
  ArrowUp: "ArrowUp",
  ArrowDown: "ArrowDown",
  PageUp: "PageUp",
  PageDown: "PageDown",
  Home: "Home",
  End: "End"
};
const SLIDER_VALUE_NOW_ATTR = "aria-valuenow";
const HORIZONTAL_KEY_DELTAS = {
  [SliderKey.ArrowLeft]: -2,
  [SliderKey.ArrowRight]: SliderValue.Step,
  [SliderKey.PageDown]: -10,
  [SliderKey.PageUp]: SliderValue.PageStep
};
const VERTICAL_KEY_DELTAS = {
  [SliderKey.ArrowLeft]: -2,
  [SliderKey.ArrowRight]: SliderValue.Step,
  [SliderKey.ArrowUp]: -2,
  [SliderKey.ArrowDown]: SliderValue.Step,
  [SliderKey.PageUp]: -10,
  [SliderKey.PageDown]: SliderValue.PageStep
};
const ABSOLUTE_KEY_POSITIONS = {
  [SliderKey.Home]: SliderValue.Minimum,
  [SliderKey.End]: SliderValue.Maximum
};
function ownKey(map, key) {
  return Object.prototype.hasOwnProperty.call(map, key);
}
function normalizeSliderPosition(position) {
  return Number.isFinite(position) ? Number(
    clamp$1(position, SliderValue.Minimum, SliderValue.Maximum).toFixed(
      SliderValue.Precision
    )
  ) : SliderValue.Default;
}
function sliderPositionFromPointer(point, box, orientation) {
  const vertical = orientation === Orientation.Vertical;
  const extent = vertical ? box.height : box.width;
  if (extent <= 0) {
    return void 0;
  }
  const offset = vertical ? point.clientY - box.top : point.clientX - box.left;
  return normalizeSliderPosition(offset / extent * SliderValue.Maximum);
}
function sliderPositionForKey(key, current, orientation) {
  if (ownKey(ABSOLUTE_KEY_POSITIONS, key)) {
    return ABSOLUTE_KEY_POSITIONS[key];
  }
  const deltas = orientation === Orientation.Vertical ? VERTICAL_KEY_DELTAS : HORIZONTAL_KEY_DELTAS;
  return ownKey(deltas, key) ? normalizeSliderPosition(current + deltas[key]) : void 0;
}
function formatSliderPosition(position) {
  return percent(position);
}
class ZygSlider extends ContentComponent {
  #frame = null;
  #handle = null;
  #frameRect = null;
  #dragging = false;
  setup() {
    const { frameSelector, handleSelector } = this.sliderConfig;
    this.#frame = this.query(frameSelector);
    this.#handle = this.query(handleSelector);
    if (!this.#frame) {
      return;
    }
    this.listen(this.#frame, EVENT_POINTERDOWN, this.#handlePointerDown);
    this.listen(this.#frame, EVENT_POINTERMOVE, this.#handlePointerMove);
    this.listen(this.#frame, EVENT_POINTERUP, this.#handlePointerUp);
    this.listen(this.#frame, EVENT_POINTERCANCEL, this.#handlePointerUp);
    this.listen(window, EVENT_SCROLL$1, this.#invalidateFrameRect, {
      passive: true,
      capture: true
    });
    this.listen(window, EVENT_RESIZE$2, this.#invalidateFrameRect, { passive: true });
    if (this.#handle) {
      this.listen(this.#handle, EVENT_KEYDOWN$1, this.#handleKeyDown);
    }
  }
  teardown() {
    this.#stopDragging();
  }
  #orientation() {
    return this.getAttribute(this.sliderConfig.orientationAttribute) ?? "";
  }
  #invalidateFrameRect = () => {
    this.#frameRect = null;
  };
  #measureFrame() {
    if (!this.#frame) {
      return null;
    }
    this.#frameRect ??= this.#frame.getBoundingClientRect();
    return this.#frameRect;
  }
  #currentPosition() {
    const parsed = Number.parseFloat(
      this.style.getPropertyValue(this.sliderConfig.positionVar).trim()
    );
    return Number.isFinite(parsed) ? normalizeSliderPosition(parsed) : SliderValue.Default;
  }
  #setPosition(position) {
    const normalized = normalizeSliderPosition(position);
    this.style.setProperty(this.sliderConfig.positionVar, formatSliderPosition(normalized));
    this.#handle?.setAttribute(SLIDER_VALUE_NOW_ATTR, String(normalized));
  }
  #positionFromPointer(event) {
    const rect = this.#measureFrame();
    return (rect && sliderPositionFromPointer(event, rect, this.#orientation())) ?? this.#currentPosition();
  }
  #startsOnPassThrough(target) {
    const { passThroughSelector } = this.sliderConfig;
    return Boolean(
      passThroughSelector && target instanceof Element && target.closest(passThroughSelector)
    );
  }
  #stopDragging() {
    this.#dragging = false;
    this.#frameRect = null;
    this.classList.remove(this.sliderConfig.draggingClass);
  }
  #handlePointerDown = (event) => {
    if (this.#startsOnPassThrough(event.target)) {
      return;
    }
    event.preventDefault();
    this.#dragging = true;
    this.#frameRect = null;
    this.classList.add(this.sliderConfig.draggingClass);
    this.#frame?.setPointerCapture?.(event.pointerId);
    this.#setPosition(this.#positionFromPointer(event));
  };
  #handlePointerMove = (event) => {
    if (!this.#dragging) {
      return;
    }
    this.#setPosition(this.#positionFromPointer(event));
  };
  #handlePointerUp = (event) => {
    if (!this.#dragging) {
      return;
    }
    this.#frame?.releasePointerCapture?.(event.pointerId);
    this.#stopDragging();
  };
  #handleKeyDown = (event) => {
    const next = sliderPositionForKey(event.key, this.#currentPosition(), this.#orientation());
    if (next === void 0) {
      return;
    }
    event.preventDefault();
    this.#setPosition(next);
  };
}
const BeforeAfterDataAttr = {
  Direction: "data-direction",
  Frame: "data-zyg-before-after-frame",
  Handle: "data-zyg-before-after-handle"
};
const BEFORE_AFTER_POSITION_VAR = "--zyg-new-before-after-pos";
const BEFORE_AFTER_DRAGGING_CLASS = "zyg-new-before-after--dragging";
const BEFORE_AFTER_PASS_THROUGH_SELECTOR = "a, button, video";
const ELEMENT_NAME$d = "zyg-new-before-after";
const SELECTOR_FRAME = `[${BeforeAfterDataAttr.Frame}]`;
const SELECTOR_HANDLE = `[${BeforeAfterDataAttr.Handle}]`;
const BEFORE_AFTER_SLIDER_CONFIG = {
  frameSelector: SELECTOR_FRAME,
  handleSelector: SELECTOR_HANDLE,
  positionVar: BEFORE_AFTER_POSITION_VAR,
  orientationAttribute: BeforeAfterDataAttr.Direction,
  draggingClass: BEFORE_AFTER_DRAGGING_CLASS,
  passThroughSelector: BEFORE_AFTER_PASS_THROUGH_SELECTOR
};
class ZygNewBeforeAfter extends ZygSlider {
  constructor() {
    super(...arguments);
    this.sliderConfig = BEFORE_AFTER_SLIDER_CONFIG;
  }
}
registerElement(ELEMENT_NAME$d, ZygNewBeforeAfter);
const ELEMENT_NAME$c = "zyg-new-countdown";
const DIGIT_STYLE_FLIP = "flip";
const EXPIRATION_BEHAVIOR_HIDE = "hide";
class ZygNewCountdown extends CountdownElement {
  #flipsDigits = false;
  setup() {
    this.#flipsDigits = this.getAttribute(CountdownRootAttr.DigitStyle) === DIGIT_STYLE_FLIP;
    super.setup();
  }
  renderUnit(el, value) {
    if (el.textContent === value) {
      return;
    }
    el.textContent = value;
    if (!this.#flipsDigits) {
      return;
    }
    el.setAttribute(
      COUNTDOWN_FLIP_PHASE_ATTR,
      nextCountdownFlipPhase(el.getAttribute(COUNTDOWN_FLIP_PHASE_ATTR))
    );
  }
  onExpired() {
    if (this.getAttribute(CountdownRootAttr.ExpirationBehavior) === EXPIRATION_BEHAVIOR_HIDE) {
      this.classList.add(COUNTDOWN_EXPIRED_HIDDEN_CLASS);
    }
  }
}
registerElement(ELEMENT_NAME$c, ZygNewCountdown);
const ELEMENT_NAME$b = "zyg-new-header";
const CART_DRAWER_ELEMENT = "zyg-cart-drawer";
const ATTR_DESKTOP_LAYOUT = "data-desktop-layout";
const ATTR_MENU_OPEN_TRIGGER = "data-menu-open-trigger";
const ATTR_DRAWER_OPEN = "data-drawer-open";
const ATTR_HIDDEN = "hidden";
const ATTR_STICKY = "data-sticky";
const LAYOUT_DRAWER = "drawer";
const TRIGGER_CLICK = "click";
const SELECTOR_HAMBURGER = "[data-zyg-header-hamburger]";
const SELECTOR_OVERLAY$1 = "[data-zyg-header-overlay]";
const SELECTOR_CART = "[data-zyg-header-cart]";
const SELECTOR_ITEM$2 = "[data-zyg-header-item]";
const SELECTOR_TRIGGER$2 = "[data-zyg-header-trigger]";
const SELECTOR_SHOPIFY_SECTION = ".shopify-section";
const CLASS_ITEM_OPEN = "is-open";
const CLASS_SOLID = "is-solid";
const CLASS_DRAWER_LOCK = "zyg-new-header-drawer-open";
const ID_HEADER_SCROLL_TRACKER = "header-scroll-tracker";
const EVENT_ALLOW_TRANSPARENT = "header:allow-transparent-header";
const EVENT_DISABLE_TRANSPARENT = "header:disable-transparent-header";
const EVENT_CLICK = "click";
const EVENT_RESIZE$1 = "resize";
const EVENT_KEYDOWN = "keydown";
const VAR_HEADER_HEIGHT = "--header-height";
const VAR_HEADER_IS_STICKY = "--header-is-sticky";
const STICKY_FLAG_ON = "1";
const STICKY_FLAG_OFF = "0";
const VAR_MENU_TOP = "--zyg-new-header-menu-top";
const MEDIA_DRAWER_VIEWPORT = "(max-width: 999px)";
const UNIT_PX = "px";
const LISTENER_PASSIVE = { passive: true };
const ATTR_VALUE_TRUE = "true";
const ATTR_VALUE_FALSE = "false";
class ZygNewHeader extends ContentComponent {
  #trackerObserver = null;
  setup() {
    this.#syncRootProperties();
    this.listen(window, EVENT_RESIZE$1, () => this.#syncRootProperties(), LISTENER_PASSIVE);
    this.#observeScrollTracker();
    const menuButton = this.query(SELECTOR_HAMBURGER);
    if (menuButton) {
      this.listen(menuButton, EVENT_CLICK, () => this.#toggleDrawer());
    }
    const overlay = this.query(SELECTOR_OVERLAY$1);
    if (overlay) {
      this.listen(overlay, EVENT_CLICK, () => this.#setDrawerOpen(false));
    }
    this.listen(document, EVENT_KEYDOWN, (event) => this.#onKeydown(event));
    const cart = this.query(SELECTOR_CART);
    if (cart) {
      this.listen(cart, EVENT_CLICK, () => this.#openCart());
    }
    this.queryAll(SELECTOR_TRIGGER$2).forEach((trigger) => {
      this.listen(trigger, EVENT_CLICK, (event) => this.#onTriggerClick(event, trigger));
    });
    this.listen(document, EVENT_ALLOW_TRANSPARENT, () => this.classList.remove(CLASS_SOLID));
    this.listen(document, EVENT_DISABLE_TRANSPARENT, () => this.classList.add(CLASS_SOLID));
  }
  teardown() {
    this.#trackerObserver?.disconnect();
    this.#trackerObserver = null;
    this.#setDrawerOpen(false);
  }
  #observeScrollTracker() {
    if (typeof IntersectionObserver !== "function") {
      return;
    }
    const tracker = document.getElementById(ID_HEADER_SCROLL_TRACKER);
    if (!tracker) {
      return;
    }
    this.#trackerObserver = new IntersectionObserver(
      (entries) => this.#onTrackerIntersect(entries)
    );
    this.#trackerObserver.observe(tracker);
  }
  #onTrackerIntersect(entries) {
    const entry = entries[0];
    if (!entry) {
      return;
    }
    this.classList.toggle(CLASS_SOLID, !entry.isIntersecting);
  }
  #syncRootProperties() {
    if (!isElementVisible(this)) {
      return;
    }
    const headerHeight = this.offsetHeight;
    const menuTop = this.hasAttribute(ATTR_DRAWER_OPEN) ? this.#measureMenuTop() : null;
    const rootStyle = document.documentElement.style;
    rootStyle.setProperty(VAR_HEADER_HEIGHT, `${headerHeight}${UNIT_PX}`);
    rootStyle.setProperty(
      VAR_HEADER_IS_STICKY,
      this.hasAttribute(ATTR_STICKY) ? STICKY_FLAG_ON : STICKY_FLAG_OFF
    );
    if (menuTop !== null) {
      this.#setMenuTop(menuTop);
    }
  }
  #measureMenuTop() {
    return Math.max(
      this.getBoundingClientRect().bottom,
      this.closest(SELECTOR_SHOPIFY_SECTION)?.getBoundingClientRect().bottom ?? 0
    );
  }
  #setMenuTop(menuTop) {
    this.style.setProperty(VAR_MENU_TOP, `${menuTop}${UNIT_PX}`);
  }
  #toggleDrawer() {
    this.#setDrawerOpen(!this.hasAttribute(ATTR_DRAWER_OPEN));
  }
  #setDrawerOpen(open) {
    if (open) {
      this.#setMenuTop(this.#measureMenuTop());
    } else {
      this.#closeOpenItems();
    }
    this.toggleAttribute(ATTR_DRAWER_OPEN, open);
    this.query(SELECTOR_HAMBURGER)?.setAttribute(
      ATTR_ARIA_EXPANDED,
      open ? ATTR_VALUE_TRUE : ATTR_VALUE_FALSE
    );
    this.query(SELECTOR_OVERLAY$1)?.toggleAttribute(ATTR_HIDDEN, !open);
    document.documentElement.classList.toggle(CLASS_DRAWER_LOCK, open);
  }
  #onKeydown(event) {
    if (event.key !== KEY_ESCAPE) {
      return;
    }
    this.#closeOpenItems();
    this.#setDrawerOpen(false);
  }
  #openCart() {
    const drawer = document.querySelector(CART_DRAWER_ELEMENT);
    if (typeof drawer?.open !== "function") {
      return;
    }
    void drawer.open();
  }
  #usesClickMenus() {
    return window.matchMedia(MEDIA_DRAWER_VIEWPORT).matches || this.getAttribute(ATTR_DESKTOP_LAYOUT) === LAYOUT_DRAWER || this.getAttribute(ATTR_MENU_OPEN_TRIGGER) === TRIGGER_CLICK;
  }
  #onTriggerClick(event, trigger) {
    if (!this.#usesClickMenus()) {
      return;
    }
    event.preventDefault();
    const item = trigger.closest(SELECTOR_ITEM$2);
    if (!item) {
      return;
    }
    const willOpen = !item.classList.contains(CLASS_ITEM_OPEN);
    this.#closeOpenItems(item);
    this.#setItemOpen(item, willOpen);
  }
  #setItemOpen(item, open) {
    item.classList.toggle(CLASS_ITEM_OPEN, open);
    const trigger = item.querySelector(SELECTOR_TRIGGER$2);
    trigger?.setAttribute(ATTR_ARIA_EXPANDED, open ? ATTR_VALUE_TRUE : ATTR_VALUE_FALSE);
  }
  #closeOpenItems(keep) {
    this.queryAll(SELECTOR_ITEM$2).forEach((item) => {
      if (keep !== void 0 && (item === keep || item.contains(keep))) {
        return;
      }
      this.#setItemOpen(item, false);
    });
  }
}
registerElement(ELEMENT_NAME$b, ZygNewHeader);
const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
const ELEMENT_NAME$a = "zyg-scroll-scrub-hero";
const ATTR_SCRUB_VIDEO$1 = "data-zyg-hero-scrub";
const CLASS_SCRUB_PIN = "zyg-hero__scrub-pin";
const SELECTOR_SCRUB_VIDEO$1 = `video[${ATTR_SCRUB_VIDEO$1}]`;
const SELECTOR_SCRUB_PIN = `.${CLASS_SCRUB_PIN}`;
const REDUCED_MOTION_QUERY$1 = "(prefers-reduced-motion: reduce)";
const ANALYTICS_CATEGORY$1 = "scroll_scrub_hero";
const ANALYTICS_ACTION_INIT$1 = "scroll_scrub_init";
const ANALYTICS_ACTION_PROGRESS = "scroll_scrub_progress";
const PROGRESS_MILESTONES = [0.25, 0.5, 0.75, 1];
const PROGRESS_MIN$2 = 0;
const PROGRESS_MAX$2 = 1;
class ZygScrollScrubHero extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY$1 }) {
  #video = null;
  #pin = null;
  #observer = null;
  #rafId = null;
  #inView = false;
  #milestoneIndex = 0;
  #reducedMotion = false;
  setup() {
    this.#reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY$1).matches;
    this.#video = this.query(SELECTOR_SCRUB_VIDEO$1);
    this.#pin = this.query(SELECTOR_SCRUB_PIN);
    if (!this.#video || !this.#pin) {
      return;
    }
    this.#video.pause();
    this.track(ANALYTICS_ACTION_INIT$1, this.#initDetail());
    if (this.#reducedMotion) {
      return;
    }
    this.#observer = new IntersectionObserver((entries) => {
      this.#inView = entries.some((e) => e.isIntersecting);
      if (this.#inView) {
        this.#schedule();
      }
    });
    this.#observer.observe(this);
    this.listen(window, EVENT_SCROLL$1, this.#onScroll, { passive: true });
    this.listen(window, EVENT_RESIZE$2, this.#onScroll);
    this.#schedule();
  }
  teardown() {
    if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null;
    }
    if (this.#rafId !== null) {
      window.cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
    this.#milestoneIndex = 0;
    this.#inView = false;
  }
  #onScroll = () => {
    this.#schedule();
  };
  #schedule() {
    if (this.#rafId !== null) {
      return;
    }
    this.#rafId = requestAnimationFrame(() => {
      this.#rafId = null;
      this.#update();
    });
  }
  #update() {
    if (!this.#video || !this.#inView) {
      return;
    }
    const duration = this.#video.duration;
    if (!Number.isFinite(duration) || duration <= 0) {
      return;
    }
    const rect = this.getBoundingClientRect();
    const scrollable = rect.height - window.innerHeight;
    const progress = scrollable <= 0 ? PROGRESS_MIN$2 : clamp(-rect.top / scrollable, PROGRESS_MIN$2, PROGRESS_MAX$2);
    const currentTime = progress * duration;
    this.#video.currentTime = currentTime;
    this.#trackMilestones(progress);
  }
  #trackMilestones(progress) {
    while (this.#milestoneIndex < PROGRESS_MILESTONES.length && progress >= PROGRESS_MILESTONES[this.#milestoneIndex]) {
      const milestone = PROGRESS_MILESTONES[this.#milestoneIndex];
      this.track(ANALYTICS_ACTION_PROGRESS, {
        milestone
      });
      this.#milestoneIndex += 1;
    }
  }
  #initDetail() {
    const duration = this.#video?.duration ?? 0;
    return {
      duration: Number.isFinite(duration) ? duration : 0,
      reducedMotion: this.#reducedMotion
    };
  }
}
registerElement(ELEMENT_NAME$a, ZygScrollScrubHero);
class TextInputComponent extends ContentComponent {
  #input = null;
  get input() {
    return this.#input;
  }
  /** Trimmed field value, empty while the field is missing. */
  get inputValue() {
    return this.#input?.value.trim() ?? "";
  }
  /** Resolves the remaining subclass DOM. */
  setupInput() {
    return true;
  }
  /** Runs on each edit of the field. */
  onInput() {
  }
  /** Runs before the field handles the key, so an override can claim navigation keys. */
  onKeydown(_event) {
  }
  /** Runs after the field handles the key, for work that needs the settled value. */
  onKeyup(_event) {
  }
  setup() {
    this.#input = this.query(this.inputSelector);
    if (!this.#input || !this.setupInput()) {
      return;
    }
    this.listen(this.#input, EVENT_INPUT, this.#handleInput);
    this.listen(this.#input, EVENT_KEYDOWN$1, this.#handleKeydown);
    this.listen(this.#input, EVENT_KEYUP, this.#handleKeyup);
  }
  setInputAttribute(name, value) {
    this.#input?.setAttribute(name, value);
  }
  removeInputAttribute(name) {
    this.#input?.removeAttribute(name);
  }
  #handleInput = () => {
    this.onInput();
  };
  #handleKeydown = (event) => {
    this.onKeydown(event);
  };
  #handleKeyup = (event) => {
    this.onKeyup(event);
  };
}
const ELEMENT_NAME$9 = "zyg-blog-search";
const CLASS_INPUT = "zyg-blog-search__input";
const CLASS_PANEL$2 = "zyg-blog-search__panel";
const CLASS_RESULTS = "zyg-blog-search__results";
const CLASS_EMPTY = "zyg-blog-search__empty";
const CLASS_RESULT = "zyg-blog-search__result";
const CLASS_LIST_WRAP = "zyg-blog-search__list-wrap";
const CLASS_STATUS = "zyg-blog-search__status";
const SELECTOR_INPUT = `.${CLASS_INPUT}`;
const SELECTOR_PANEL$2 = `.${CLASS_PANEL$2}`;
const SELECTOR_RESULTS = `.${CLASS_RESULTS}`;
const SELECTOR_EMPTY = `.${CLASS_EMPTY}`;
const SELECTOR_RESULT = `.${CLASS_RESULT}`;
const SELECTOR_LIST_WRAP = `.${CLASS_LIST_WRAP}`;
const SELECTOR_STATUS = `.${CLASS_STATUS}`;
const SELECTOR_RESULT_ITEM = "li";
const ATTR_LIMIT = "data-zyg-blog-search-limit";
const ATTR_RESULT_COUNT = "data-zyg-blog-search-count";
const ATTR_ANNOUNCEMENT = "data-zyg-blog-search-announcement";
const RESULTS_SECTION_ID = "zyg-blog-search-results";
const OPTION_ID_SUFFIX = "-option-";
const AUTOCOMPLETE_DELAY_MS = 280;
const MIN_QUERY_LENGTH = 1;
const DEFAULT_RESULTS_LIMIT = 6;
const SCROLL_BLOCK_NEAREST = "nearest";
const NAVIGATION_KEYS = [KEY_ARROW_DOWN, KEY_ARROW_UP, KEY_ENTER];
const SEARCH_FAILED_WARNING = "zyg-blog-search: article suggestion request failed";
const SHOPIFY_FEATURES_ELEMENT_ID = "shopify-features";
const PREDICTIVE_SEARCH_FEATURE_KEY = "predictiveSearch";
const DEFAULT_ROUTES_ROOT = "/";
const SEARCH_PATH = "search";
const SUGGEST_PATH = "search/suggest";
const RESOURCE_TYPE_ARTICLE = "article";
const LIMIT_SCOPE_EACH = "each";
const SHOPIFY_SECTION_SELECTOR = ".shopify-section";
const ABORT_ERROR_NAME = "AbortError";
const PARAM_QUERY = "q";
const PARAM_TYPE = "type";
const PARAM_RESOURCE_TYPE = "resources[type]";
const PARAM_RESOURCE_LIMIT = "resources[limit]";
const PARAM_RESOURCE_LIMIT_SCOPE = "resources[limit_scope]";
const PARAM_SECTION_ID = "section_id";
function routesRoot() {
  return window.Shopify?.routes?.root ?? DEFAULT_ROUTES_ROOT;
}
function supportsPredictiveApi() {
  const features = document.getElementById(SHOPIFY_FEATURES_ELEMENT_ID)?.textContent;
  if (!features) {
    return false;
  }
  try {
    const parsed = JSON.parse(features);
    return parsed[PREDICTIVE_SEARCH_FEATURE_KEY] === true;
  } catch {
    return false;
  }
}
function buildSuggestUrl(query, limit) {
  const predictive = supportsPredictiveApi();
  const params = new URLSearchParams(
    predictive ? {
      [PARAM_QUERY]: query,
      [PARAM_RESOURCE_TYPE]: RESOURCE_TYPE_ARTICLE,
      [PARAM_RESOURCE_LIMIT]: String(limit),
      [PARAM_RESOURCE_LIMIT_SCOPE]: LIMIT_SCOPE_EACH,
      [PARAM_SECTION_ID]: RESULTS_SECTION_ID
    } : {
      [PARAM_QUERY]: query,
      [PARAM_TYPE]: RESOURCE_TYPE_ARTICLE,
      [PARAM_SECTION_ID]: RESULTS_SECTION_ID
    }
  );
  return `${routesRoot()}${predictive ? SUGGEST_PATH : SEARCH_PATH}?${params.toString()}`;
}
function parseSectionFragment(html) {
  return new DOMParser().parseFromString(html, "text/html").querySelector(SHOPIFY_SECTION_SELECTOR);
}
function isAbortError(error) {
  return error instanceof DOMException && error.name === ABORT_ERROR_NAME;
}
class ZygBlogSearch extends TextInputComponent {
  #panel = null;
  #results = null;
  #empty = null;
  #status = null;
  #controller;
  #search;
  #activeIndex = INDEX_NONE;
  #cachedOptions = [];
  get inputSelector() {
    return SELECTOR_INPUT;
  }
  setupInput() {
    this.#panel = this.query(SELECTOR_PANEL$2);
    this.#results = this.query(SELECTOR_RESULTS);
    this.#empty = this.query(SELECTOR_EMPTY);
    this.#status = this.query(SELECTOR_STATUS);
    if (!this.#panel || !this.#results) {
      return false;
    }
    this.#search = debounce(this.#fetchResults, AUTOCOMPLETE_DELAY_MS);
    this.listen(document, EVENT_CLICK$1, this.#closeOnOutsideClick);
    return true;
  }
  teardown() {
    this.#search?.cancel();
    this.#controller?.abort();
  }
  get #limit() {
    return parseIntOrZero(this.getAttribute(ATTR_LIMIT) ?? void 0) || DEFAULT_RESULTS_LIMIT;
  }
  onInput() {
    if (this.inputValue.length >= MIN_QUERY_LENGTH) {
      this.#search?.();
      return;
    }
    this.#close();
  }
  #fetchResults = () => {
    const query = this.inputValue;
    if (!isNotEmpty(query)) {
      return;
    }
    this.#controller?.abort();
    this.#controller = new AbortController();
    fetch(buildSuggestUrl(query, this.#limit), { signal: this.#controller.signal }).then((response) => response.text()).then((html) => this.#render(parseSectionFragment(html))).catch((error) => {
      if (!isAbortError(error)) {
        console.warn(SEARCH_FAILED_WARNING, error);
        this.#close();
      }
    });
  };
  #render(fragment) {
    if (!this.#results) {
      return;
    }
    this.#results.replaceChildren(...fragment ? Array.from(fragment.children) : []);
    this.#activeIndex = INDEX_NONE;
    this.#cachedOptions = this.#capRows();
    this.#cachedOptions.forEach((option, index) => {
      option.id = `${this.id}${OPTION_ID_SUFFIX}${index}`;
    });
    const wrap = this.#results.querySelector(SELECTOR_LIST_WRAP);
    const matched = parseIntOrZero(wrap?.getAttribute(ATTR_RESULT_COUNT) ?? void 0) > 0;
    if (this.#empty) {
      this.#empty.hidden = matched;
    }
    this.#announce(matched ? wrap?.getAttribute(ATTR_ANNOUNCEMENT) : this.#empty?.textContent);
    this.#open();
  }
  #capRows() {
    const rendered = this.queryAll(SELECTOR_RESULT);
    rendered.slice(this.#limit).forEach((option) => (option.closest(SELECTOR_RESULT_ITEM) ?? option).remove());
    return rendered.slice(0, this.#limit);
  }
  #announce(message) {
    if (this.#status) {
      this.#status.textContent = message ?? "";
    }
  }
  #open() {
    if (!this.#panel) {
      return;
    }
    this.#panel.hidden = false;
    this.setInputAttribute(ATTR_ARIA_EXPANDED, boolToString(true));
  }
  #close() {
    this.#search?.cancel();
    this.#controller?.abort();
    if (!this.#panel) {
      return;
    }
    this.#panel.hidden = true;
    this.#activeIndex = INDEX_NONE;
    this.#cachedOptions = [];
    this.#announce(void 0);
    this.setInputAttribute(ATTR_ARIA_EXPANDED, boolToString(false));
    this.removeInputAttribute(ATTR_ARIA_ACTIVE_DESCENDANT);
  }
  #nextIndex(key, count) {
    if (this.#activeIndex === INDEX_NONE) {
      return key === KEY_ARROW_DOWN ? 0 : count - 1;
    }
    return (this.#activeIndex + (key === KEY_ARROW_DOWN ? 1 : -1) + count) % count;
  }
  #setActive(index, options) {
    this.#activeIndex = index;
    options.forEach((option, position) => {
      option.setAttribute(ATTR_ARIA_SELECTED$1, boolToString(position === index));
    });
    this.setInputAttribute(ATTR_ARIA_ACTIVE_DESCENDANT, options[index].id);
    options[index].scrollIntoView({ block: SCROLL_BLOCK_NEAREST });
  }
  onKeydown(event) {
    if (event.key === KEY_ESCAPE) {
      this.#close();
      return;
    }
    if (!NAVIGATION_KEYS.includes(event.key)) {
      return;
    }
    const options = this.#cachedOptions;
    if (options.length === 0 || this.#panel?.hidden !== false) {
      return;
    }
    if (event.key === KEY_ARROW_DOWN || event.key === KEY_ARROW_UP) {
      event.preventDefault();
      this.#setActive(this.#nextIndex(event.key, options.length), options);
      return;
    }
    if (event.key === KEY_ENTER && this.#activeIndex !== INDEX_NONE) {
      event.preventDefault();
      navigateToUrl(options[this.#activeIndex].href);
    }
  }
  #closeOnOutsideClick = (event) => {
    if (!this.contains(event.target)) {
      this.#close();
    }
  };
}
registerElement(ELEMENT_NAME$9, ZygBlogSearch);
const ELEMENT_NAME$8 = "zyg-info-popup";
const DOM_EVENT_INFO_POPUP_CLICK = "zyg:info-popup:click";
const CLASS_TRIGGER_BUTTON = "zyg-info-popup__button";
const SELECTOR_TRIGGER_BUTTON = `.${CLASS_TRIGGER_BUTTON}`;
const ATTR_ARIA_CONTROLS = "aria-controls";
class ZygInfoPopup extends ContentComponent {
  setup() {
    const button = this.query(SELECTOR_TRIGGER_BUTTON);
    if (!button) {
      return;
    }
    this.listen(button, EVENT_CLICK$1, () => {
      this.emit(DOM_EVENT_INFO_POPUP_CLICK, {
        id: button.getAttribute(ATTR_ARIA_CONTROLS)
      });
    });
  }
}
registerElement(ELEMENT_NAME$8, ZygInfoPopup);
const EVENT_SHOPIFY_BLOCK_SELECT = "shopify:block:select";
const EVENT_SHOPIFY_BLOCK_DESELECT = "shopify:block:deselect";
const ELEMENT_NAME$7 = "zyg-hot-spot";
const DOM_EVENT_HOT_SPOT_OPEN = "zyg:hot-spot:open";
const CLASS_TRIGGER = "zyg-hot-spot__trigger";
const CLASS_PANEL$1 = "zyg-hot-spot__panel";
const CLASS_CLOSE = "zyg-hot-spot__close";
const SELECTOR_TRIGGER$1 = `.${CLASS_TRIGGER}`;
const SELECTOR_PANEL$1 = `.${CLASS_PANEL$1}`;
const SELECTOR_CLOSE = `.${CLASS_CLOSE}`;
const ATTR_OPEN = "data-zyg-hot-spot-open";
const ATTR_HOVER = "data-zyg-hot-spot-hover";
const HOVER_MEDIA_QUERY = "(min-width: 700px) and (hover: hover)";
class ZygHotSpot extends ContentComponent {
  #trigger = null;
  #pointerInside = false;
  setup() {
    this.#trigger = this.query(SELECTOR_TRIGGER$1);
    if (!this.#trigger) {
      return;
    }
    this.listen(this.#trigger, EVENT_CLICK$1, this.#toggle);
    const closeButton = this.query(SELECTOR_CLOSE);
    if (closeButton) {
      this.listen(closeButton, EVENT_CLICK$1, this.#close);
    }
    if (this.hasAttribute(ATTR_HOVER) && window.matchMedia(HOVER_MEDIA_QUERY).matches) {
      this.listen(this, EVENT_MOUSEENTER, this.#pointerEnter);
      this.listen(this, EVENT_MOUSELEAVE, this.#pointerLeave);
    }
    this.listen(document, EVENT_CLICK$1, this.#closeOnOutsideClick);
    this.listen(document, EVENT_KEYDOWN$1, this.#closeOnEscape);
    this.listen(document, DOM_EVENT_HOT_SPOT_OPEN, this.#closeWhenAnotherOpens);
    this.listen(document, EVENT_SHOPIFY_BLOCK_SELECT, this.#openWhenSelected);
    this.listen(document, EVENT_SHOPIFY_BLOCK_DESELECT, this.#closeWhenDeselected);
  }
  #toggle = () => {
    if (this.hasAttribute(ATTR_OPEN) && !this.#pointerInside) {
      this.#close();
      return;
    }
    this.#open();
  };
  #pointerEnter = () => {
    this.#pointerInside = true;
    this.#open();
  };
  #pointerLeave = () => {
    this.#pointerInside = false;
    this.#close();
  };
  #open = () => {
    if (this.hasAttribute(ATTR_OPEN)) {
      return;
    }
    this.setAttribute(ATTR_OPEN, "");
    this.#trigger?.setAttribute(ATTR_ARIA_EXPANDED, boolToString(true));
    this.emit(DOM_EVENT_HOT_SPOT_OPEN, {});
  };
  #close = () => {
    if (!this.hasAttribute(ATTR_OPEN)) {
      return;
    }
    const panel = this.query(SELECTOR_PANEL$1);
    const focusWasInPanel = panel?.contains(document.activeElement) === true;
    this.removeAttribute(ATTR_OPEN);
    this.#trigger?.setAttribute(ATTR_ARIA_EXPANDED, boolToString(false));
    if (focusWasInPanel) {
      this.#trigger?.focus();
    }
  };
  #closeOnOutsideClick = (event) => {
    if (!this.contains(event.target)) {
      this.#close();
    }
  };
  #closeOnEscape = (event) => {
    if (event.key === KEY_ESCAPE) {
      this.#close();
    }
  };
  #closeWhenAnotherOpens = (event) => {
    if (event.target !== this) {
      this.#close();
    }
  };
  #openWhenSelected = (event) => {
    if (this.contains(event.target)) {
      this.#open();
    }
  };
  #closeWhenDeselected = (event) => {
    if (this.contains(event.target)) {
      this.#close();
    }
  };
}
registerElement(ELEMENT_NAME$7, ZygHotSpot);
const ELEMENT_NAME$6 = "zyg-modal";
const CLASS_MODAL_BLOCK = "zyg-modal-block";
const SELECTOR_MODAL_BLOCK = `.${CLASS_MODAL_BLOCK}`;
const SELECTOR_X_MODAL = "x-modal";
const ATTR_MODAL_ELEMENT_ID = "data-modal-element-id";
const ATTR_CLOSE_ON_OVERLAY = "data-close-on-overlay";
const CLOSE_ON_OVERLAY_OFF = "false";
const PART_OVERLAY = "overlay";
const SELECTOR_OVERLAY_PART = `[part="${PART_OVERLAY}"]`;
const EVENT_BLOCK_SELECT = "shopify:block:select";
const EVENT_BLOCK_DESELECT = "shopify:block:deselect";
class ZygModal extends ContentComponent {
  #dialog = null;
  setup() {
    this.#dialog = this.#resolveDialog();
    if (!this.#dialog) {
      return;
    }
    const editorHost = this.closest(SELECTOR_MODAL_BLOCK) ?? this;
    this.listen(editorHost, EVENT_BLOCK_SELECT, this.#showDialog);
    this.listen(editorHost, EVENT_BLOCK_DESELECT, this.#hideDialog);
    if (this.getAttribute(ATTR_CLOSE_ON_OVERLAY) === CLOSE_ON_OVERLAY_OFF) {
      this.#lockOverlayClose();
    }
  }
  #resolveDialog() {
    const elementId = this.getAttribute(ATTR_MODAL_ELEMENT_ID);
    const byId = elementId ? document.getElementById(elementId) : null;
    const found = byId ?? this.query(SELECTOR_X_MODAL);
    return found;
  }
  #showDialog = () => {
    this.#dialog?.show();
  };
  #hideDialog = () => {
    this.#dialog?.hide();
  };
  #lockOverlayClose() {
    const overlay = this.#dialog?.shadowRoot?.querySelector(SELECTOR_OVERLAY_PART);
    if (!overlay) {
      return;
    }
    this.listen(overlay, EVENT_CLICK$1, this.#stopOverlayClose, { capture: true });
  }
  #stopOverlayClose = (event) => {
    event.stopImmediatePropagation();
  };
}
registerElement(ELEMENT_NAME$6, ZygModal);
const ARIA_HIDDEN_ATTRIBUTE = "aria-hidden";
const ARIA_HIDDEN_FALSE = "false";
const ARIA_HIDDEN_TRUE = "true";
const PERCENT_MULTIPLIER = 100;
const PROGRESS_MIN$1 = 0;
const PROGRESS_MAX$1 = 1;
function parseProgressPercent(value) {
  if (value === null || value === "") {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? clamp$1(parsed, PROGRESS_MIN$1, PERCENT_MULTIPLIER) : null;
}
function overlayBindings(root, options) {
  return Array.from(root.querySelectorAll(options.selector)).map((element) => {
    const start = parseProgressPercent(
      element.getAttribute(options.startAttribute)
    );
    const end = parseProgressPercent(
      element.getAttribute(options.endAttribute)
    );
    return start === null || end === null ? null : {
      element,
      start,
      end,
      blockId: element.getAttribute(options.blockIdAttribute) ?? element.id,
      seen: false,
      visible: null
    };
  }).filter(
    (binding) => binding !== null
  );
}
function createScrollableVideoOverlayController(root, options) {
  let bindings = overlayBindings(root, options);
  return {
    get count() {
      return bindings.length;
    },
    get startPercents() {
      return bindings.map(({ start }) => start);
    },
    update() {
      bindings = overlayBindings(root, options);
    },
    sync: (progress) => {
      const percent2 = clamp$1(progress, PROGRESS_MIN$1, PROGRESS_MAX$1) * PERCENT_MULTIPLIER;
      bindings.forEach((overlay) => {
        const visible = overlay.end >= overlay.start && percent2 >= overlay.start && percent2 <= overlay.end;
        if (overlay.visible === visible) {
          return;
        }
        overlay.visible = visible;
        overlay.element.classList.toggle(options.visibleClass, visible);
        overlay.element.setAttribute(
          ARIA_HIDDEN_ATTRIBUTE,
          visible ? ARIA_HIDDEN_FALSE : ARIA_HIDDEN_TRUE
        );
        if (visible && !overlay.seen) {
          overlay.seen = true;
          options.onSeen({
            blockId: overlay.blockId,
            start: overlay.start,
            end: overlay.end
          });
        }
      });
    }
  };
}
function createScrollableVideoSeekController(video, options) {
  let pendingTime = null;
  let seekInFlight = false;
  const flush = () => {
    if (pendingTime === null || seekInFlight || video.seeking) {
      return;
    }
    if (Math.abs(video.currentTime - pendingTime) < options.seekEpsilonSeconds) {
      pendingTime = null;
      return;
    }
    video.pause();
    seekInFlight = true;
    const target = pendingTime;
    if (typeof video.fastSeek === "function") {
      video.fastSeek?.(target);
    } else {
      video.currentTime = target;
    }
    if (!video.seeking) {
      seekInFlight = false;
      if (pendingTime !== null && Math.abs(video.currentTime - pendingTime) < options.seekEpsilonSeconds) {
        pendingTime = null;
      }
    }
  };
  return {
    sync: (progress) => {
      if (!Number.isFinite(video.duration) || video.duration <= 0) {
        return;
      }
      pendingTime = clamp$1(
        (options.reducedMotionProgress ?? progress) * video.duration,
        PROGRESS_MIN$1,
        video.duration
      );
      flush();
    },
    onSeeked: () => {
      seekInFlight = false;
      flush();
    }
  };
}
function scrollableVideoProgress(scrollY, offsetTop, scrollable) {
  return scrollable <= 0 ? PROGRESS_MIN$1 : clamp$1((scrollY - offsetTop) / scrollable, PROGRESS_MIN$1, PROGRESS_MAX$1);
}
const BLOCK_ID_ATTRIBUTE = "data-zyg-block-id";
const ELEMENT_NAME$5 = "zyg-scrollable-video";
const ATTR_SCRUB_VIDEO = "data-zyg-scrollable-video";
const CLASS_PIN = "zyg-scrollable-video__pin";
const CLASS_OVERLAY = "zyg-scrollable-video__overlay";
const CLASS_PROGRESS_MARKER = "zyg-scrollable-video__progress-marker";
const CLASS_IS_READY = "is-ready";
const CLASS_IS_VISIBLE = "is-visible";
const ATTR_START = "data-start";
const ATTR_END = "data-end";
const ATTR_PROGRESS_FILL = "data-zyg-scrollable-video-progress-fill";
const ATTR_PROGRESS_LABEL = "data-zyg-scrollable-video-progress-label";
const ATTR_PROGRESS_MARKERS = "data-zyg-scrollable-video-progress-markers";
const SELECTOR_SCRUB_VIDEO = `video[${ATTR_SCRUB_VIDEO}]`;
const SELECTOR_PIN = `.${CLASS_PIN}`;
const SELECTOR_OVERLAY = `.${CLASS_OVERLAY}`;
const SELECTOR_PROGRESS_FILL$1 = `[${ATTR_PROGRESS_FILL}]`;
const SELECTOR_PROGRESS_LABEL = `[${ATTR_PROGRESS_LABEL}]`;
const SELECTOR_PROGRESS_MARKERS = `[${ATTR_PROGRESS_MARKERS}]`;
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
const ANALYTICS_CATEGORY = "scrollable_video";
const ANALYTICS_ACTION_INIT = "scrollable_video_init";
const ANALYTICS_ACTION_OVERLAY_SEEN = "overlay_seen";
const EVENT_SEEKED = "seeked";
const EVENT_LOADED_METADATA$1 = "loadedmetadata";
const REDUCED_MOTION_PROGRESS = 0.5;
const SEEK_EPSILON_SECONDS = 0.01;
class ZygScrollableVideo extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY }) {
  #video = null;
  #pin = null;
  #progressFill = null;
  #progressLabel = null;
  #overlays = null;
  #seek = null;
  #observer = null;
  #resizeObserver = null;
  #rafId = null;
  #inView = false;
  #reducedMotion = false;
  #offsetTop = 0;
  #scrollable = 0;
  setup() {
    this.#reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;
    this.#video = this.query(SELECTOR_SCRUB_VIDEO);
    this.#pin = this.query(SELECTOR_PIN);
    this.#progressFill = this.query(SELECTOR_PROGRESS_FILL$1);
    this.#progressLabel = this.query(SELECTOR_PROGRESS_LABEL);
    this.#overlays = createScrollableVideoOverlayController(this, {
      selector: SELECTOR_OVERLAY,
      startAttribute: ATTR_START,
      endAttribute: ATTR_END,
      blockIdAttribute: BLOCK_ID_ATTRIBUTE,
      visibleClass: CLASS_IS_VISIBLE,
      onSeen: ({ blockId, start, end }) => this.track(ANALYTICS_ACTION_OVERLAY_SEEN, {
        blockId,
        start,
        end
      })
    });
    this.#syncProgressMarkers();
    if (!this.#video || !this.#pin) {
      return;
    }
    this.#seek = createScrollableVideoSeekController(this.#video, {
      reducedMotionProgress: this.#reducedMotion ? REDUCED_MOTION_PROGRESS : null,
      seekEpsilonSeconds: SEEK_EPSILON_SECONDS
    });
    this.#video.pause();
    this.classList.add(CLASS_IS_READY);
    this.track(ANALYTICS_ACTION_INIT, this.#initDetail());
    this.listen(this.#video, EVENT_SEEKED, this.#onSeeked);
    this.listen(this.#video, EVENT_LOADED_METADATA$1, this.#schedule);
    this.#observer = new IntersectionObserver((entries) => {
      this.#inView = entries.some((entry) => entry.isIntersecting);
      if (this.#inView) {
        this.#measureLayout();
        this.#schedule();
      }
    });
    this.#observer.observe(this);
    if (typeof ResizeObserver !== "undefined") {
      this.#resizeObserver = new ResizeObserver(this.#onLayoutChange);
      this.#resizeObserver.observe(this);
    }
    this.listen(window, EVENT_SCROLL$1, this.#schedule, { passive: true });
    this.listen(window, EVENT_RESIZE$2, this.#onLayoutChange);
    this.#measureLayout();
    this.#schedule();
  }
  teardown() {
    if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null;
    }
    if (this.#resizeObserver) {
      this.#resizeObserver.disconnect();
      this.#resizeObserver = null;
    }
    if (this.#rafId !== null) {
      window.cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
    this.#inView = false;
    this.#overlays = null;
    this.#seek = null;
    this.#offsetTop = 0;
    this.#scrollable = 0;
    this.classList.remove(CLASS_IS_READY);
  }
  #onSeeked = () => {
    this.#seek?.onSeeked();
  };
  #onLayoutChange = () => {
    this.#measureLayout();
    this.#schedule();
  };
  #schedule = () => {
    if (this.#rafId !== null) {
      return;
    }
    this.#rafId = requestAnimationFrame(() => {
      this.#rafId = null;
      this.#update();
    });
  };
  #update() {
    if (!this.#seek || !this.#inView) {
      return;
    }
    const progress = this.#computeProgress();
    this.#seek.sync(progress);
    this.#overlays?.sync(progress);
    this.#syncProgressBar(progress);
  }
  #measureLayout() {
    const rect = this.getBoundingClientRect();
    this.#offsetTop = rect.top + window.scrollY;
    this.#scrollable = rect.height - window.innerHeight;
  }
  #computeProgress() {
    return scrollableVideoProgress(window.scrollY, this.#offsetTop, this.#scrollable);
  }
  #syncProgressBar(progress) {
    if (!this.#progressFill && !this.#progressLabel) {
      return;
    }
    if (this.#progressFill) {
      this.#progressFill.style.setProperty(CSS_PROP_TRANSFORM, cssScaleX(progress));
    }
    if (this.#progressLabel) {
      this.#progressLabel.textContent = `${Math.round(progress * PERCENTAGE_MULTIPLIER)}${PERCENT_UNIT$1}`;
    }
  }
  #syncProgressMarkers() {
    const container = this.query(SELECTOR_PROGRESS_MARKERS);
    if (!container) {
      return;
    }
    container.replaceChildren(
      ...(this.#overlays?.startPercents ?? []).map((start) => {
        const marker = document.createElement(TAG_SPAN);
        marker.className = CLASS_PROGRESS_MARKER;
        marker.setAttribute(ATTR_START, String(start));
        marker.style.setProperty(CSS_PROP_LEFT, `${start}${PERCENT_UNIT$1}`);
        return marker;
      })
    );
  }
  #initDetail() {
    const durationSec = this.#video?.duration ?? 0;
    return {
      durationSec: Number.isFinite(durationSec) ? durationSec : 0,
      reducedMotion: this.#reducedMotion,
      overlayCount: this.#overlays?.count ?? 0
    };
  }
}
registerElement(ELEMENT_NAME$5, ZygScrollableVideo);
const NO_INDEX = -1;
function closestIndex(values, target) {
  return values.reduce(
    (bestIndex, value, index) => bestIndex === NO_INDEX || Math.abs(value - target) < Math.abs(values[bestIndex] - target) ? index : bestIndex,
    NO_INDEX
  );
}
const TIMELINE_VIEWPORT_ANCHOR_RATIO = 0.5;
const EVENT_RESIZE = "resize";
const EVENT_SCROLL = "scroll";
const PASSIVE_EVENT_OPTIONS = { passive: true };
class TimelineHighlightController {
  #root;
  #options;
  #observer = null;
  #rafId = null;
  #inView = false;
  #activeIndex = NO_INDEX;
  #items = [];
  constructor(root, options) {
    this.#root = root;
    this.#options = options;
  }
  start() {
    this.stop();
    this.#items = Array.from(
      this.#root.querySelectorAll(this.#options.itemSelector)
    );
    if (this.#items.length === 0) {
      return;
    }
    this.#setActiveIndex(0);
    if (typeof IntersectionObserver !== "undefined") {
      this.#observer = new IntersectionObserver((entries) => {
        this.#inView = entries.some((entry) => entry.isIntersecting);
        if (this.#inView) {
          this.#schedule();
        }
      });
      this.#observer.observe(this.#root);
    }
    window.addEventListener(
      EVENT_SCROLL,
      this.#schedule,
      PASSIVE_EVENT_OPTIONS
    );
    window.addEventListener(
      EVENT_RESIZE,
      this.#schedule,
      PASSIVE_EVENT_OPTIONS
    );
    this.#schedule();
  }
  stop() {
    window.removeEventListener(
      EVENT_SCROLL,
      this.#schedule,
      PASSIVE_EVENT_OPTIONS
    );
    window.removeEventListener(
      EVENT_RESIZE,
      this.#schedule,
      PASSIVE_EVENT_OPTIONS
    );
    this.#observer?.disconnect();
    this.#observer = null;
    if (this.#rafId !== null) {
      window.cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
    this.#clearActive();
    this.#inView = false;
    this.#activeIndex = NO_INDEX;
    this.#items = [];
  }
  #schedule = () => {
    if (this.#rafId !== null) {
      return;
    }
    this.#rafId = window.requestAnimationFrame(() => {
      this.#rafId = null;
      this.#update();
    });
  };
  #update() {
    if (this.#items.length === 0 || !this.#inView && !this.#isRootInView()) {
      return;
    }
    const anchor = window.innerHeight * (this.#options.viewportAnchorRatio ?? TIMELINE_VIEWPORT_ANCHOR_RATIO);
    const nextIndex = closestIndex(
      this.#items.map((item) => {
        const rect = item.getBoundingClientRect();
        return rect.top + rect.height / 2;
      }),
      anchor
    );
    if (nextIndex !== NO_INDEX && nextIndex !== this.#activeIndex) {
      this.#setActiveIndex(nextIndex);
    }
  }
  #isRootInView() {
    const rect = this.#root.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }
  #clearActive() {
    if (this.#activeIndex !== NO_INDEX) {
      this.#items[this.#activeIndex]?.classList.remove(
        this.#options.activeClass
      );
    }
  }
  #setActiveIndex(index) {
    this.#clearActive();
    this.#items[index]?.classList.add(this.#options.activeClass);
    this.#activeIndex = index;
  }
}
class TimelineElement extends ContentComponent {
  #controller = null;
  setup() {
    if (this.classList.contains(this.names.horizontalClass) || !this.classList.contains(this.names.highlightClass)) {
      return;
    }
    this.#controller = new TimelineHighlightController(this, {
      itemSelector: this.names.itemSelector,
      activeClass: this.names.itemActiveClass
    });
    this.#controller.start();
  }
  teardown() {
    this.#controller?.stop();
    this.#controller = null;
  }
}
const ELEMENT_NAME$4 = "zyg-timeline";
const CLASS_HIGHLIGHT_ON_SCROLL$1 = "zyg-timeline--highlight-on-scroll";
const CLASS_STEPS = "zyg-timeline--steps";
const CLASS_HORIZONTAL$1 = "zyg-timeline--horizontal";
const CLASS_ITEM$1 = "zyg-timeline__item";
const CLASS_ITEM_ACTIVE$1 = `${CLASS_ITEM$1}--active`;
const CLASS_STEP_ACTIVE = "zyg-timeline__step--active";
const SELECTOR_ITEM$1 = `.${CLASS_ITEM$1}`;
const SELECTOR_ITEMS = "[data-timeline-items]";
const SELECTOR_STEP = `:scope > [${ATTR_BLOCK_ID}]`;
const SELECTOR_PREV$1 = "[data-timeline-prev]";
const SELECTOR_NEXT$1 = "[data-timeline-next]";
const SCROLL_BEHAVIOR_SMOOTH = "smooth";
const SCROLL_BEHAVIOR_AUTO = "auto";
const TIMELINE_NAMES = {
  highlightClass: CLASS_HIGHLIGHT_ON_SCROLL$1,
  horizontalClass: CLASS_HORIZONTAL$1,
  itemActiveClass: CLASS_ITEM_ACTIVE$1,
  itemSelector: SELECTOR_ITEM$1
};
class ZygTimeline extends TimelineElement {
  constructor() {
    super(...arguments);
    this.names = TIMELINE_NAMES;
    this.#horizontalRafId = null;
    this.#horizontalIndex = 0;
    this.#steps = [];
    this.#itemsEl = null;
    this.#prevBtn = null;
    this.#nextBtn = null;
    this.#onPrevClick = () => {
      this.#scrollToIndex(this.#horizontalIndex - 1);
    };
    this.#onNextClick = () => {
      this.#scrollToIndex(this.#horizontalIndex + 1);
    };
    this.#onItemsScroll = () => {
      this.#scheduleStepsSync();
    };
    this.#onStepsResize = () => {
      this.#scrollToIndex(this.#horizontalIndex, false);
    };
  }
  #horizontalRafId;
  #horizontalIndex;
  #steps;
  #itemsEl;
  #prevBtn;
  #nextBtn;
  setup() {
    if (this.classList.contains(CLASS_STEPS)) {
      this.#setupSteps();
    }
    super.setup();
  }
  teardown() {
    if (this.#horizontalRafId !== null) {
      window.cancelAnimationFrame(this.#horizontalRafId);
      this.#horizontalRafId = null;
    }
    this.#horizontalIndex = 0;
    this.#steps = [];
    this.#itemsEl = null;
    this.#prevBtn = null;
    this.#nextBtn = null;
    super.teardown();
  }
  #setupSteps() {
    this.#itemsEl = this.query(SELECTOR_ITEMS);
    this.#prevBtn = this.query(SELECTOR_PREV$1);
    this.#nextBtn = this.query(SELECTOR_NEXT$1);
    if (!this.#itemsEl) {
      return;
    }
    this.#steps = Array.from(this.#itemsEl.querySelectorAll(SELECTOR_STEP));
    if (this.#steps.length === 0) {
      return;
    }
    this.#setActiveStep(0);
    this.#scrollToIndex(0, false);
    this.#updateArrowState();
    if (this.#prevBtn) {
      this.listen(this.#prevBtn, EVENT_CLICK$1, this.#onPrevClick);
    }
    if (this.#nextBtn) {
      this.listen(this.#nextBtn, EVENT_CLICK$1, this.#onNextClick);
    }
    this.listen(this.#itemsEl, EVENT_SCROLL$1, this.#onItemsScroll, { passive: true });
    this.listen(window, EVENT_RESIZE$2, this.#onStepsResize, { passive: true });
  }
  #onPrevClick;
  #onNextClick;
  #onItemsScroll;
  #onStepsResize;
  #scheduleStepsSync() {
    if (this.#horizontalRafId !== null) {
      return;
    }
    this.#horizontalRafId = requestAnimationFrame(() => {
      this.#horizontalRafId = null;
      this.#syncActiveStepFromScroll();
      this.#updateArrowState();
    });
  }
  #setActiveStep(index) {
    if (this.#horizontalIndex !== index && this.#steps[this.#horizontalIndex]) {
      this.#steps[this.#horizontalIndex].classList.remove(CLASS_STEP_ACTIVE);
    }
    this.#horizontalIndex = index;
    this.#steps[index]?.classList.add(CLASS_STEP_ACTIVE);
  }
  #scrollToIndex(index, smooth = true) {
    if (!this.#itemsEl || this.#steps.length === 0) {
      return;
    }
    const nextIndex = Math.max(0, Math.min(index, this.#steps.length - 1));
    const target = this.#steps[nextIndex];
    if (!target) {
      return;
    }
    this.#setActiveStep(nextIndex);
    const left = this.#startAlignedScrollLeft(target);
    const behavior = smooth ? SCROLL_BEHAVIOR_SMOOTH : SCROLL_BEHAVIOR_AUTO;
    if (typeof this.#itemsEl.scrollTo === "function") {
      this.#itemsEl.scrollTo({ left, behavior });
    } else {
      this.#itemsEl.scrollLeft = left;
    }
    this.#updateArrowState();
  }
  #startAlignedScrollLeft(step) {
    if (!this.#itemsEl) {
      return 0;
    }
    const maxScroll = Math.max(0, this.#itemsEl.scrollWidth - this.#itemsEl.clientWidth);
    return Math.max(0, Math.min(step.offsetLeft, maxScroll));
  }
  #syncActiveStepFromScroll() {
    if (!this.#itemsEl || this.#steps.length === 0) {
      return;
    }
    const trackRect = this.#itemsEl.getBoundingClientRect();
    const trackMid = trackRect.left + trackRect.width / 2;
    const centers = this.#steps.map((step) => {
      const rect = step.getBoundingClientRect();
      return rect.left + rect.width / 2;
    });
    const nextIndex = closestIndex(centers, trackMid);
    if (nextIndex === INDEX_NONE || nextIndex === this.#horizontalIndex) {
      return;
    }
    this.#setActiveStep(nextIndex);
  }
  #updateArrowState() {
    if (!this.#itemsEl) {
      return;
    }
    const scrollable = this.#itemsEl.scrollWidth - this.#itemsEl.clientWidth > 0;
    if (this.#prevBtn) {
      this.#prevBtn.disabled = !scrollable || this.#horizontalIndex <= 0;
    }
    if (this.#nextBtn) {
      this.#nextBtn.disabled = !scrollable || this.#horizontalIndex >= this.#steps.length - 1;
    }
  }
}
registerElement(ELEMENT_NAME$4, ZygTimeline);
const ELEMENT_NAME$3 = "zyg-new-timeline";
const CLASS_HORIZONTAL = "zyg-new-timeline--horizontal";
const CLASS_HIGHLIGHT_ON_SCROLL = "zyg-new-timeline--highlight-on-scroll";
const CLASS_ENTRY = "zyg-new-timeline__entry";
const CLASS_ENTRY_ACTIVE = `${CLASS_ENTRY}--active`;
const SELECTOR_ENTRY = `.${CLASS_ENTRY}`;
const NEW_TIMELINE_NAMES = {
  highlightClass: CLASS_HIGHLIGHT_ON_SCROLL,
  horizontalClass: CLASS_HORIZONTAL,
  itemActiveClass: CLASS_ENTRY_ACTIVE,
  itemSelector: SELECTOR_ENTRY
};
class ZygNewTimeline extends TimelineElement {
  constructor() {
    super(...arguments);
    this.names = NEW_TIMELINE_NAMES;
  }
}
registerElement(ELEMENT_NAME$3, ZygNewTimeline);
const PURCHASE_TYPE_OTP = "otp";
const PURCHASE_TYPE_SUBSCRIPTION = "subscription";
const UPSELL_TYPE_PRODUCT = "product";
const UPSELL_TYPE_UPSELL = "upsell";
const UPSELL_TYPE_CROSS_SELL = "cross_sell";
const FIELD_PURCHASE_TYPE = "purchase_type";
const FIELD_UPSELL_TYPE = "upsell_type";
const KNOWN_UPSELL_TYPES = /* @__PURE__ */ new Set([
  UPSELL_TYPE_PRODUCT,
  UPSELL_TYPE_UPSELL,
  UPSELL_TYPE_CROSS_SELL
]);
function classifyProductAdd(input) {
  return {
    [FIELD_PURCHASE_TYPE]: purchaseTypeOf(input),
    [FIELD_UPSELL_TYPE]: upsellTypeOf(input)
  };
}
function purchaseTypeOf(input) {
  if (input.purchaseType === PURCHASE_TYPE_OTP || input.purchaseType === PURCHASE_TYPE_SUBSCRIPTION) {
    return input.purchaseType;
  }
  if (input.hasSellingPlan || input.sellingPlanId || input.initialOffer === PURCHASE_TYPE_SUBSCRIPTION) {
    return PURCHASE_TYPE_SUBSCRIPTION;
  }
  return PURCHASE_TYPE_OTP;
}
function upsellTypeOf(input) {
  if (input.upsellType && KNOWN_UPSELL_TYPES.has(input.upsellType)) {
    return input.upsellType;
  }
  if (input.source === UPSELL_TYPE_CROSS_SELL) {
    return UPSELL_TYPE_CROSS_SELL;
  }
  if (input.isUpsell || input.source === UPSELL_TYPE_UPSELL) {
    return UPSELL_TYPE_UPSELL;
  }
  return UPSELL_TYPE_PRODUCT;
}
const FIELD_UPSELL_PLACEMENT = "upsell_placement";
const FIELD_UPSELL_WIDGET_ID = "upsell_widget_id";
const FIELD_UPSELL_ANCHOR_PRODUCT_ID = "upsell_anchor_product_id";
function upsellEventFields(context) {
  return {
    [FIELD_UPSELL_PLACEMENT]: context.placement,
    [FIELD_UPSELL_WIDGET_ID]: context.widgetId,
    ...context.anchorProductId && {
      [FIELD_UPSELL_ANCHOR_PRODUCT_ID]: context.anchorProductId
    }
  };
}
class CallToActionEvent {
  /** Builds the detail object for DOM CustomEvents */
  buildEventDetail(context) {
    return {
      action: this.type,
      variantId: context.variantId,
      productId: context.productId,
      quantity: context.quantity,
      sellingPlanId: context.sellingPlanId,
      ...classifyProductAdd({
        sellingPlanId: context.sellingPlanId,
        isUpsell: context.isUpsell
      }),
      ...context.upsellContext && upsellEventFields(context.upsellContext)
    };
  }
}
const ERROR_UNKNOWN = "Unknown error";
class CartActionBase extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.domEvent = "zyg:cta:add-to-cart:success";
    this.domEventError = "zyg:cta:add-to-cart:error";
    this.analyticsAction = "cta_add_to_cart";
    this.analyticsActionError = "cta_add_to_cart_error";
    this.requiresAvailability = true;
    this.errorMissingVariant = "[cta] Missing variant ID for add to cart";
    this.errorCartNotAvailable = "[cta] Cart not available";
    this.errorAddFailed = "[cta] Failed to add to cart:";
  }
  validate(context) {
    if (!context.variantId) {
      return { valid: false, error: this.errorMissingVariant };
    }
    return { valid: true };
  }
  /** Reports cart add error - shared by all cart actions */
  reportError(context, host, error) {
    const errorMessage = error instanceof Error ? error.message : ERROR_UNKNOWN;
    console.error(`${this.errorAddFailed} ${errorMessage}`);
    const detail = { ...this.buildEventDetail(context), error: errorMessage };
    host.emitError(this.domEventError, this.analyticsActionError, detail);
  }
}
class AddToCartAction extends CartActionBase {
  constructor() {
    super(...arguments);
    this.type = "add-to-cart";
  }
  async execute(context, host) {
    host.setLoading(true);
    try {
      await host.executeCartAdd(context);
      const detail = this.buildEventDetail(context);
      host.emitAndTrack(this.domEvent, this.analyticsAction, { ...detail, success: true });
      host.showAddedFeedback();
    } catch (error) {
      this.reportError(context, host, error);
    } finally {
      host.setLoading(false);
    }
  }
}
class NavigateAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "go-to-page";
    this.domEvent = "zyg:cta:navigate";
    this.analyticsAction = "cta_navigate";
    this.requiresAvailability = false;
    this.errorMissingUrl = "[cta] Missing link URL for navigation";
  }
  validate(context) {
    if (!context.linkUrl) {
      return { valid: false, error: this.errorMissingUrl };
    }
    return { valid: true };
  }
  buildEventDetail(context) {
    return { url: context.linkUrl, newTab: context.openNewTab };
  }
  execute(context, host) {
    if (!context.linkUrl) {
      return;
    }
    const detail = this.buildEventDetail(context);
    host.emitAndTrack(this.domEvent, this.analyticsAction, detail);
    if (context.openNewTab) {
      window.open(context.linkUrl, WINDOW_TARGET_BLANK, WINDOW_FEATURES_SECURE);
      return;
    }
    window.location.href = context.linkUrl;
  }
}
const STRAIGHT_TO_CHECKOUT_OPTIONS = {
  skipDrawer: true,
  clearFirst: true,
  forCheckout: true
};
class StraightToCheckoutAction extends CartActionBase {
  constructor() {
    super(...arguments);
    this.type = "straight-to-checkout";
  }
  buildEventDetail(context) {
    return { ...super.buildEventDetail(context), checkout: true, replaced: true };
  }
  async execute(context, host) {
    host.setLoading(true);
    try {
      await host.executeCartAdd(context, STRAIGHT_TO_CHECKOUT_OPTIONS);
      const detail = this.buildEventDetail(context);
      host.emitAndTrack(this.domEvent, this.analyticsAction, { ...detail, success: true });
      window.location.href = context.freeShippingDiscountCode ? buildDiscountRedirectUrl(context.freeShippingDiscountCode, CHECKOUT_URL) : CHECKOUT_URL;
    } catch (error) {
      this.reportError(context, host, error);
      host.setLoading(false);
    }
  }
}
const EASE_FACTOR = 0.12;
const ARRIVAL_TOLERANCE_PX = 2;
const MIN_STEP_PX = 1;
const MAX_SCROLL_DURATION_MS = 3e3;
const DOM_EVENT_SCROLL = "zyg:cta:scroll";
const ANALYTICS_ACTION_SCROLL_TO = "cta_scroll";
const ANALYTICS_ACTION_SCROLL_TO_SHOP = "cta_scroll_to_shop";
const ANALYTICS_ACTION_SCROLL_TO_BUYBOX = "cta_scroll_to_buybox";
const ACTION_SCROLL_TO$1 = "scroll-to";
const ACTION_SCROLL_TO_SHOP$1 = "scroll-to-shop";
const ACTION_SCROLL_TO_BUYBOX$1 = "scroll-to-buybox";
const ERROR_MISSING_SCROLL_TARGET = "[cta] Missing scroll target";
const ERROR_INVALID_SCROLL_SELECTOR = "[cta] Invalid scroll target selector:";
const ERROR_SCROLL_TARGET_NOT_FOUND = "[cta] Scroll target not found:";
const ERROR_SHOP_SECTION_NOT_FOUND = "[cta] Shop section not found on page";
const ERROR_BUYBOX_SECTION_NOT_FOUND = "[cta] Buybox section not found on page";
let activeScrollRafId = null;
function scrollToElement(element) {
  if (activeScrollRafId !== null) {
    window.cancelAnimationFrame(activeScrollRafId);
    activeScrollRafId = null;
  }
  const startTime = performance.now();
  function step() {
    if (!element.isConnected) {
      activeScrollRafId = null;
      return;
    }
    const rect = element.getBoundingClientRect();
    const offset = rect.top;
    if (Math.abs(offset) <= ARRIVAL_TOLERANCE_PX || performance.now() - startTime > MAX_SCROLL_DURATION_MS) {
      activeScrollRafId = null;
      return;
    }
    const scrollYBefore = window.scrollY;
    const raw = offset * EASE_FACTOR;
    const px = Math.abs(raw) < MIN_STEP_PX ? Math.sign(raw) * MIN_STEP_PX : Math.round(raw);
    window.scrollBy(0, px);
    if (window.scrollY === scrollYBefore) {
      activeScrollRafId = null;
      return;
    }
    activeScrollRafId = requestAnimationFrame(step);
  }
  activeScrollRafId = requestAnimationFrame(step);
}
const SHOP_SECTION_SELECTOR = '[id*="zyg-shop-section"], [id*="zyg_shop_section"]';
const BUYBOX_SECTION_SELECTOR = '[id*="zyg-buybox"], [id*="zyg_buybox"], .zyg-buybox';
function findShopSection() {
  return document.querySelector(SHOP_SECTION_SELECTOR);
}
function findBuyboxSection() {
  return document.querySelector(BUYBOX_SECTION_SELECTOR);
}
class SectionScrollAction extends CallToActionEvent {
  constructor(config) {
    super();
    this.domEvent = DOM_EVENT_SCROLL;
    this.requiresAvailability = false;
    this.type = config.type;
    this.analyticsAction = config.analyticsAction;
    this.targetSelector = config.targetSelector;
    this.findElement = config.findElement;
    this.missingTargetMessage = config.missingTargetMessage;
  }
  validate(_context) {
    return { valid: true };
  }
  buildEventDetail(_context) {
    return { target: this.targetSelector };
  }
  execute(context, host) {
    const element = this.findElement();
    if (!element) {
      console.error(this.missingTargetMessage);
      return;
    }
    host.emitAndTrack(this.domEvent, this.analyticsAction, this.buildEventDetail(context));
    scrollToElement(element);
  }
}
class ScrollToAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = ACTION_SCROLL_TO$1;
    this.domEvent = DOM_EVENT_SCROLL;
    this.analyticsAction = ANALYTICS_ACTION_SCROLL_TO;
    this.requiresAvailability = false;
    this.errorMissingTarget = ERROR_MISSING_SCROLL_TARGET;
    this.errorInvalidSelector = ERROR_INVALID_SCROLL_SELECTOR;
    this.errorTargetNotFound = ERROR_SCROLL_TARGET_NOT_FOUND;
  }
  validate(context) {
    if (!context.scrollTarget) {
      return { valid: false, error: this.errorMissingTarget };
    }
    return { valid: true };
  }
  buildEventDetail(context) {
    return { target: context.scrollTarget };
  }
  execute(context, host) {
    if (!context.scrollTarget) {
      return;
    }
    let element;
    try {
      element = document.querySelector(context.scrollTarget);
    } catch {
      console.error(this.errorInvalidSelector, context.scrollTarget);
      return;
    }
    if (!element) {
      console.error(this.errorTargetNotFound, context.scrollTarget);
      return;
    }
    const detail = this.buildEventDetail(context);
    host.emitAndTrack(this.domEvent, this.analyticsAction, detail);
    scrollToElement(element);
  }
}
class ScrollToShopAction extends SectionScrollAction {
  constructor() {
    super({
      type: ACTION_SCROLL_TO_SHOP$1,
      analyticsAction: ANALYTICS_ACTION_SCROLL_TO_SHOP,
      targetSelector: SHOP_SECTION_SELECTOR,
      findElement: findShopSection,
      missingTargetMessage: ERROR_SHOP_SECTION_NOT_FOUND
    });
    this.errorShopSectionNotFound = ERROR_SHOP_SECTION_NOT_FOUND;
  }
}
class ScrollToBuyboxAction extends SectionScrollAction {
  constructor() {
    super({
      type: ACTION_SCROLL_TO_BUYBOX$1,
      analyticsAction: ANALYTICS_ACTION_SCROLL_TO_BUYBOX,
      targetSelector: BUYBOX_SECTION_SELECTOR,
      findElement: findBuyboxSection,
      missingTargetMessage: ERROR_BUYBOX_SECTION_NOT_FOUND
    });
    this.errorBuyboxSectionNotFound = ERROR_BUYBOX_SECTION_NOT_FOUND;
  }
}
class SubmitFormAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "submit-form";
    this.domEvent = "zyg:cta:submit-form";
    this.analyticsAction = "cta_submit_form";
    this.requiresAvailability = false;
  }
  validate(_context) {
    return { valid: true };
  }
  buildEventDetail(_context) {
    return { action: this.type };
  }
  /** No-op: #handleClick returns before preventDefault so the browser posts the form. */
  execute(_context, _host) {
    return;
  }
}
const HANDLEIZE_COMBINING_MARKS = /[̀-ͯ]/g;
const HANDLEIZE_SHARP_S = /ß/g;
const HANDLEIZE_SHARP_S_SPELLING = "ss";
const HANDLEIZE_DROPPED = /['"()[\]]/g;
const HANDLEIZE_NON_WORD_ASCII = /[^a-z0-9_\u0080-\u{10ffff}]+/gu;
const HANDLEIZE_EDGE_HYPHENS = /^-+|-+$/g;
const HANDLEIZE_REMOVED = "";
const HANDLEIZE_HYPHEN = "-";
const DECOMPOSED_FORM = "NFD";
function handleize(value) {
  return value.toLowerCase().normalize(DECOMPOSED_FORM).replace(HANDLEIZE_COMBINING_MARKS, HANDLEIZE_REMOVED).replace(HANDLEIZE_SHARP_S, HANDLEIZE_SHARP_S_SPELLING).replace(HANDLEIZE_DROPPED, HANDLEIZE_REMOVED).replace(HANDLEIZE_NON_WORD_ASCII, HANDLEIZE_HYPHEN).replace(HANDLEIZE_EDGE_HYPHENS, HANDLEIZE_REMOVED);
}
const ZYG_MODAL_ID_PREFIX = "zyg-modal-";
function handleizeModalId(value) {
  return handleize(value);
}
function resolveZygModalElementId(modalId) {
  return `${ZYG_MODAL_ID_PREFIX}${handleizeModalId(modalId)}`;
}
class OpenModalAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "open-modal";
    this.domEvent = "zyg:cta:open-modal";
    this.analyticsAction = "cta_open_modal";
    this.requiresAvailability = false;
    this.errorMissingModalId = "[cta] Missing modal id";
    this.errorModalNotFound = "[cta] Modal not found:";
    this.errorModalMissingShow = "[cta] Modal is missing show():";
  }
  validate(context) {
    if (!context.modalId) {
      return { valid: false, error: this.errorMissingModalId };
    }
    return { valid: true };
  }
  buildEventDetail(context) {
    return { modalId: context.modalId };
  }
  execute(context, host) {
    if (!context.modalId) {
      return;
    }
    const elementId = resolveZygModalElementId(context.modalId);
    const dialog = document.getElementById(elementId);
    if (!dialog) {
      console.error(this.errorModalNotFound, elementId);
      return;
    }
    if (typeof dialog.show !== "function") {
      console.error(this.errorModalMissingShow, elementId);
      return;
    }
    host.emitAndTrack(this.domEvent, this.analyticsAction, this.buildEventDetail(context));
    dialog.show();
  }
}
const ACTION_ADD_TO_CART = "add-to-cart";
const ACTION_STRAIGHT_TO_CHECKOUT = "straight-to-checkout";
const ACTION_GO_TO_PAGE = "go-to-page";
const ACTION_SCROLL_TO = "scroll-to";
const ACTION_SCROLL_TO_SHOP = "scroll-to-shop";
const ACTION_SCROLL_TO_BUYBOX = "scroll-to-buybox";
const ACTION_SUBMIT_FORM = "submit-form";
const ACTION_OPEN_MODAL = "open-modal";
({
  [ACTION_ADD_TO_CART]: new AddToCartAction(),
  [ACTION_STRAIGHT_TO_CHECKOUT]: new StraightToCheckoutAction(),
  [ACTION_GO_TO_PAGE]: new NavigateAction(),
  [ACTION_SCROLL_TO]: new ScrollToAction(),
  [ACTION_SCROLL_TO_SHOP]: new ScrollToShopAction(),
  [ACTION_SCROLL_TO_BUYBOX]: new ScrollToBuyboxAction(),
  [ACTION_SUBMIT_FORM]: new SubmitFormAction(),
  [ACTION_OPEN_MODAL]: new OpenModalAction()
});
const ELEMENT_NAME$2 = "zyg-cta-button";
const SELECTOR_TEXT = ".zyg-cta-button__text";
const ELEMENT_NAME$1 = "zyg-tabs";
const CLASS_TRIGGER_SELECTED = "zyg-tabs__trigger--selected";
const SELECTOR_CAROUSEL = ".zyg-carousel";
const CLASS_CONTROLS = "zyg-tabs__controls";
const CLASS_PANEL = "zyg-tabs__panel";
const SELECTOR_CONTROLS = `.${CLASS_CONTROLS}`;
const SELECTOR_OWN_CONTROLS = `:scope > ${SELECTOR_CONTROLS}`;
const SELECTOR_PANEL = `.${CLASS_PANEL}`;
const ATTR_TRIGGER_TEMPLATE = "data-zyg-tab-trigger";
const SELECTOR_TRIGGER_TEMPLATE = `template[${ATTR_TRIGGER_TEMPLATE}]`;
const SELECTOR_CTA_TRIGGER = ELEMENT_NAME$2;
const SELECTOR_THEME_TRIGGER = "button.button, a.button, button.link, a.link";
const SELECTOR_TRIGGER = `${SELECTOR_CTA_TRIGGER}, ${SELECTOR_THEME_TRIGGER}`;
const LISTENER_CAPTURE = { capture: true };
const SELECTOR_TABS = ELEMENT_NAME$1;
const EVENT_CAROUSEL_CHANGE = "zyg-carousel:change";
const METHOD_GO_TO_SLIDE = "goToSlide";
const DETAIL_INDEX = "index";
const ATTR_ARIA_SELECTED = "aria-selected";
const ARIA_SELECTED_TRUE = "true";
const ARIA_SELECTED_FALSE = "false";
const INDEX_FIRST = 0;
const STEP_NUMBER_OFFSET = 1;
const ATTR_STEP_TEMPLATE = "data-zyg-tabs-step-template";
const PLACEHOLDER_STEP_NUMBER = "{n}";
const SELECTOR_BUTTON_CONTENT = "button-content";
const SELECTOR_TRIGGER_LABEL = `${SELECTOR_TEXT}, ${SELECTOR_BUTTON_CONTENT}`;
class ZygTabs extends ContentComponent {
  #carousel = null;
  #triggers = [];
  setup() {
    this.#populateTriggersFromTemplates();
    this.#carousel = this.query(SELECTOR_CAROUSEL);
    this.#triggers = this.queryAll(SELECTOR_TRIGGER).filter(
      (el) => this.#isOwnedTrigger(el)
    );
    this.#applyStepLabels();
    if (!this.#carousel || this.#triggers.length === 0) {
      return;
    }
    this.#triggers.forEach((trigger, index) => {
      this.listen(
        trigger,
        EVENT_CLICK$1,
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.#selectIndex(index);
        },
        LISTENER_CAPTURE
      );
    });
    this.listen(this.#carousel, EVENT_CAROUSEL_CHANGE, this.#onCarouselChange);
    this.#markSelected(INDEX_FIRST);
  }
  teardown() {
    this.#carousel = null;
    this.#triggers = [];
  }
  #populateTriggersFromTemplates() {
    const controls = this.query(SELECTOR_OWN_CONTROLS);
    if (!controls) {
      return;
    }
    const clones = this.queryAll(SELECTOR_PANEL).filter((panel) => panel.closest(SELECTOR_TABS) === this).flatMap((panel) => {
      const template = panel.querySelector(SELECTOR_TRIGGER_TEMPLATE);
      return template ? [template.content.cloneNode(true)] : [];
    });
    if (clones.length === 0) {
      return;
    }
    controls.replaceChildren(...clones);
  }
  #isOwnedTrigger(el) {
    if (el.closest(SELECTOR_TABS) !== this || this.#carousel?.contains(el)) {
      return false;
    }
    const cta = el.closest(SELECTOR_CTA_TRIGGER);
    return cta === null || cta === el;
  }
  #applyStepLabels() {
    const template = this.getAttribute(ATTR_STEP_TEMPLATE)?.trim();
    if (!template?.includes(PLACEHOLDER_STEP_NUMBER)) {
      return;
    }
    this.#triggers.forEach((trigger, index) => {
      const label = template.split(PLACEHOLDER_STEP_NUMBER).join(String(index + STEP_NUMBER_OFFSET));
      const content = trigger.querySelector(SELECTOR_TRIGGER_LABEL);
      (content ?? trigger).textContent = label;
    });
  }
  #selectIndex(index) {
    this.#carousel?.[METHOD_GO_TO_SLIDE]?.(index);
    this.#markSelected(index);
  }
  #onCarouselChange = (event) => {
    if (event.target !== this.#carousel) {
      return;
    }
    const index = event.detail?.[DETAIL_INDEX];
    if (typeof index !== "number" || !Number.isInteger(index)) {
      return;
    }
    this.#markSelected(index);
  };
  #markSelected(index) {
    if (index < INDEX_FIRST || index >= this.#triggers.length) {
      return;
    }
    this.#triggers.forEach((trigger, triggerIndex) => {
      const selected = triggerIndex === index;
      trigger.classList.toggle(CLASS_TRIGGER_SELECTED, selected);
      trigger.setAttribute(
        ATTR_ARIA_SELECTED,
        selected ? ARIA_SELECTED_TRUE : ARIA_SELECTED_FALSE
      );
    });
  }
}
registerElement(ELEMENT_NAME$1, ZygTabs);
const ELEMENT_NAME = "zyg-story";
const CLASS_ITEM = "zyg-story__item";
const CLASS_ITEM_ACTIVE = `${CLASS_ITEM}--active`;
const CLASS_PROGRESS_SEGMENT = "zyg-story__progress-segment";
const CLASS_PROGRESS_FILL = "zyg-story__progress-fill";
const CLASS_VIDEO = "zyg-video";
const CLASS_ITEMS = "zyg-story__items";
const SELECTOR_MEDIA_SLIDE = `.${CLASS_ITEMS} zyg-media.zyg-media`;
const SELECTOR_VIDEO_SLIDE = `.${CLASS_ITEMS} .${CLASS_VIDEO}`;
const SELECTOR_ITEM = `.${CLASS_ITEM}, ${SELECTOR_MEDIA_SLIDE}, ${SELECTOR_VIDEO_SLIDE}`;
const PRELOAD_AUTO = "auto";
const ATTR_MUTED = "muted";
const ATTR_CONTROLS = "controls";
const SELECTOR_PROGRESS_SEGMENT = `.${CLASS_PROGRESS_SEGMENT}`;
const SELECTOR_PROGRESS_FILL = `.${CLASS_PROGRESS_FILL}`;
const SELECTOR_PREV = "[data-zyg-story-prev]";
const SELECTOR_NEXT = "[data-zyg-story-next]";
const SELECTOR_TAP_PREV = "[data-zyg-story-tap-prev]";
const SELECTOR_TAP_NEXT = "[data-zyg-story-tap-next]";
const SELECTOR_ITEM_VIDEO = "video";
const ATTR_MEDIA_TYPE = "data-media-type";
const ATTR_IMAGE_DURATION_MS = "data-image-duration-ms";
const ATTR_AUTO_LOOP = "data-auto-loop";
const AUTO_LOOP_DISABLED = "false";
const MEDIA_TYPE_VIDEO = "video";
const DEFAULT_IMAGE_DURATION_MS = 5e3;
const DEFAULT_AUTO_LOOP = true;
const EVENT_TIMEUPDATE = "timeupdate";
const EVENT_ENDED = "ended";
const EVENT_LOADED_METADATA = "loadedmetadata";
const CSS_PROP_PROGRESS = "--zyg-story-progress";
const PROGRESS_MIN = 0;
const PROGRESS_MAX = 1;
const STEP_DELTA_PREV = -1;
const STEP_DELTA_NEXT = 1;
function ignoreAutoplayRejection() {
}
class ZygStory extends ContentComponent {
  #items = [];
  #progressFills = [];
  #progressSegments = [];
  #videosByItem = /* @__PURE__ */ new Map();
  #trackingVideo = null;
  #observer = null;
  #rafId = null;
  #imageStartedAt = 0;
  #imageElapsedMs = 0;
  #inView = false;
  #activeIndex = INDEX_NONE;
  #stopped = false;
  #imageDurationMs = DEFAULT_IMAGE_DURATION_MS;
  #autoLoop = DEFAULT_AUTO_LOOP;
  setup() {
    this.#items = this.queryAll(SELECTOR_ITEM);
    this.#progressFills = this.queryAll(SELECTOR_PROGRESS_FILL);
    this.#progressSegments = this.queryAll(SELECTOR_PROGRESS_SEGMENT);
    this.#imageDurationMs = this.#readImageDurationMs();
    this.#autoLoop = this.#readAutoLoop();
    if (this.#items.length === 0) {
      return;
    }
    this.#bindControls();
    this.#bindVideos();
    this.#observer = new IntersectionObserver((entries) => {
      this.#inView = entries.some((entry) => entry.isIntersecting);
      if (this.#inView) {
        this.#onEnterView();
      } else {
        this.#onLeaveView();
      }
    });
    this.#observer.observe(this);
    this.#goTo(0, { restart: true, autoplay: false });
    this.#syncViewportPlayback();
  }
  teardown() {
    this.#stopImageTicker();
    if (this.#observer) {
      this.#observer.disconnect();
      this.#observer = null;
    }
    this.#items = [];
    this.#progressFills = [];
    this.#progressSegments = [];
    this.#videosByItem.clear();
    this.#trackingVideo = null;
    this.#activeIndex = INDEX_NONE;
    this.#inView = false;
    this.#stopped = false;
    this.#imageElapsedMs = 0;
  }
  #bindControls() {
    const controls = [
      this.query(SELECTOR_PREV),
      this.query(SELECTOR_TAP_PREV),
      this.query(SELECTOR_NEXT),
      this.query(SELECTOR_TAP_NEXT)
    ];
    controls.forEach((control) => {
      if (!control) {
        return;
      }
      this.listen(control, EVENT_CLICK$1, this.#onControlClick);
    });
  }
  #bindVideos() {
    this.#videosByItem.clear();
    this.#items.forEach((item) => {
      const videos = Array.from(item.querySelectorAll(SELECTOR_ITEM_VIDEO));
      if (videos.length === 0) {
        return;
      }
      this.#videosByItem.set(item, videos);
      videos.forEach((video) => {
        this.#prepareVideo(video);
        this.listen(video, EVENT_TIMEUPDATE, this.#onVideoTimeUpdate);
        this.listen(video, EVENT_ENDED, this.#onVideoEnded);
        this.listen(video, EVENT_LOADED_METADATA, this.#onVideoTimeUpdate);
      });
    });
  }
  #prepareVideo(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute(ATTR_MUTED, "");
    video.controls = false;
    video.removeAttribute(ATTR_CONTROLS);
    video.loop = false;
    video.playsInline = true;
    video.preload = PRELOAD_AUTO;
  }
  #onControlClick = (event) => {
    const target = event.currentTarget;
    if (!(target instanceof HTMLElement)) {
      return;
    }
    if (target.matches(SELECTOR_PREV) || target.matches(SELECTOR_TAP_PREV)) {
      this.#step(STEP_DELTA_PREV);
      return;
    }
    if (target.matches(SELECTOR_NEXT) || target.matches(SELECTOR_TAP_NEXT)) {
      this.#step(STEP_DELTA_NEXT);
    }
  };
  #step(delta) {
    const nextIndex = this.#resolveIndex(this.#activeIndex + delta);
    if (nextIndex < 0 || nextIndex >= this.#items.length) {
      return;
    }
    this.#stopped = false;
    this.#goTo(nextIndex, { restart: true, autoplay: this.#inView });
  }
  #onEnterView() {
    if (this.#stopped || this.#activeIndex === INDEX_NONE) {
      return;
    }
    this.#startActivePlayback();
  }
  #onLeaveView() {
    this.#pauseActivePlayback();
  }
  #syncViewportPlayback() {
    const rect = this.getBoundingClientRect();
    const isVisible = rect.bottom > 0 && rect.top < window.innerHeight && rect.height > 0;
    if (!isVisible) {
      return;
    }
    this.#inView = true;
    this.#onEnterView();
  }
  #goTo(index, options) {
    if (index < 0 || index >= this.#items.length) {
      return;
    }
    this.#stopImageTicker();
    this.#pauseAllVideos();
    if (this.#activeIndex !== INDEX_NONE) {
      this.#items[this.#activeIndex]?.classList.remove(CLASS_ITEM_ACTIVE);
      this.#items[this.#activeIndex]?.setAttribute(ATTR_ARIA_HIDDEN, ARIA_HIDDEN_TRUE$1);
    }
    this.#activeIndex = index;
    this.#items[index]?.classList.add(CLASS_ITEM_ACTIVE);
    this.#items[index]?.setAttribute(ATTR_ARIA_HIDDEN, ARIA_HIDDEN_FALSE$1);
    this.#trackingVideo = this.#resolveTrackingVideo(this.#items[index]);
    this.#syncProgressCompleteState(index);
    if (options.restart) {
      this.#resetActiveMedia();
      this.#imageElapsedMs = 0;
    }
    this.#setProgress(index, PROGRESS_MIN);
    this.#syncControlDisabledState();
    if (options.autoplay) {
      this.#startActivePlayback();
    }
  }
  #startActivePlayback() {
    if (this.#stopped || !this.#inView || this.#activeIndex === INDEX_NONE) {
      return;
    }
    const item = this.#items[this.#activeIndex];
    if (!item) {
      return;
    }
    if (this.#isVideoItem(item)) {
      const videos = this.#videosFor(item);
      if (videos.length > 0) {
        videos.forEach((video) => {
          void video.play().catch(ignoreAutoplayRejection);
        });
        return;
      }
    }
    this.#imageStartedAt = performance.now() - this.#imageElapsedMs;
    this.#scheduleImageTick();
  }
  #pauseActivePlayback() {
    if (this.#activeIndex === INDEX_NONE) {
      return;
    }
    const item = this.#items[this.#activeIndex];
    if (!item) {
      return;
    }
    if (this.#isVideoItem(item)) {
      this.#videosFor(item).forEach((video) => {
        video.pause();
      });
      return;
    }
    if (this.#rafId !== null) {
      this.#imageElapsedMs = Math.min(
        this.#imageDurationMs,
        performance.now() - this.#imageStartedAt
      );
      this.#stopImageTicker();
    }
  }
  #stopImageTicker() {
    if (this.#rafId === null) {
      return;
    }
    window.cancelAnimationFrame(this.#rafId);
    this.#rafId = null;
  }
  #scheduleImageTick() {
    if (this.#rafId !== null) {
      return;
    }
    this.#rafId = requestAnimationFrame(this.#onImageTick);
  }
  #onImageTick = (now) => {
    this.#rafId = null;
    if (!this.#inView || this.#stopped || this.#activeIndex === INDEX_NONE) {
      return;
    }
    const elapsed = now - this.#imageStartedAt;
    const progress = Math.min(PROGRESS_MAX, elapsed / this.#imageDurationMs);
    this.#setProgress(this.#activeIndex, progress);
    if (progress >= PROGRESS_MAX) {
      this.#advanceOrStop();
      return;
    }
    this.#scheduleImageTick();
  };
  #onVideoTimeUpdate = (event) => {
    if (!(event.currentTarget instanceof HTMLVideoElement)) {
      return;
    }
    if (this.#activeIndex === INDEX_NONE || !this.#inView) {
      return;
    }
    const item = this.#items[this.#activeIndex];
    if (!item || !this.#isTrackingVideo(item, event.currentTarget)) {
      return;
    }
    const { currentTime, duration } = event.currentTarget;
    if (!Number.isFinite(duration) || duration <= 0) {
      return;
    }
    this.#setProgress(this.#activeIndex, Math.min(PROGRESS_MAX, currentTime / duration));
  };
  #onVideoEnded = (event) => {
    if (!(event.currentTarget instanceof HTMLVideoElement)) {
      return;
    }
    if (this.#activeIndex === INDEX_NONE) {
      return;
    }
    const item = this.#items[this.#activeIndex];
    if (!item || !this.#isTrackingVideo(item, event.currentTarget)) {
      return;
    }
    this.#setProgress(this.#activeIndex, PROGRESS_MAX);
    this.#advanceOrStop();
  };
  #advanceOrStop() {
    const nextIndex = this.#activeIndex + STEP_DELTA_NEXT;
    if (nextIndex >= this.#items.length && !this.#autoLoop) {
      this.#stopped = true;
      this.#pauseActivePlayback();
      this.#syncControlDisabledState();
      return;
    }
    this.#goTo(this.#resolveIndex(nextIndex), { restart: true, autoplay: this.#inView });
  }
  #syncProgressCompleteState(activeIndex) {
    this.#progressFills.forEach((fill, index) => {
      if (index < activeIndex) {
        fill.style.setProperty(CSS_PROP_PROGRESS, cssScaleX(PROGRESS_MAX));
        return;
      }
      if (index > activeIndex) {
        fill.style.setProperty(CSS_PROP_PROGRESS, cssScaleX(PROGRESS_MIN));
      }
    });
    this.#progressSegments.forEach((segment, index) => {
      segment.setAttribute(
        ATTR_ARIA_HIDDEN,
        index === activeIndex ? ARIA_HIDDEN_FALSE$1 : ARIA_HIDDEN_TRUE$1
      );
    });
  }
  #setProgress(index, progress) {
    const fill = this.#progressFills[index];
    if (!fill) {
      return;
    }
    fill.style.setProperty(CSS_PROP_PROGRESS, cssScaleX(progress));
  }
  #resetActiveMedia() {
    const item = this.#items[this.#activeIndex];
    if (!item) {
      return;
    }
    this.#videosFor(item).forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });
  }
  #pauseAllVideos() {
    this.#videosByItem.forEach((videos) => {
      videos.forEach((video) => {
        video.pause();
      });
    });
  }
  #syncControlDisabledState() {
    const canWrap = this.#autoLoop && this.#items.length > 1;
    const atStart = !canWrap && this.#activeIndex <= 0;
    const atLast = !canWrap && this.#activeIndex >= this.#items.length - 1;
    this.#setDisabled(SELECTOR_PREV, atStart);
    this.#setDisabled(SELECTOR_TAP_PREV, atStart);
    this.#setDisabled(SELECTOR_NEXT, atLast);
    this.#setDisabled(SELECTOR_TAP_NEXT, atLast);
  }
  #setDisabled(selector, disabled) {
    const control = this.query(selector);
    if (!control) {
      return;
    }
    control.disabled = disabled;
  }
  #isVideoItem(item) {
    if (item.getAttribute(ATTR_MEDIA_TYPE) === MEDIA_TYPE_VIDEO) {
      return true;
    }
    if (item.classList.contains(CLASS_VIDEO)) {
      return true;
    }
    return this.#videosFor(item).length > 0;
  }
  #videosFor(item) {
    return this.#videosByItem.get(item) ?? [];
  }
  #visibleVideos(item) {
    return this.#videosFor(item).filter(isElementVisible);
  }
  #resolveTrackingVideo(item) {
    if (!item) {
      return null;
    }
    return this.#visibleVideos(item)[0] ?? this.#videosFor(item)[0] ?? null;
  }
  #isTrackingVideo(item, video) {
    if (this.#trackingVideo) {
      return video === this.#trackingVideo;
    }
    return this.#videosFor(item).includes(video);
  }
  #readImageDurationMs() {
    const raw = Number(this.getAttribute(ATTR_IMAGE_DURATION_MS));
    if (!Number.isFinite(raw) || raw <= 0) {
      return DEFAULT_IMAGE_DURATION_MS;
    }
    return raw;
  }
  #readAutoLoop() {
    if (this.getAttribute(ATTR_AUTO_LOOP) === AUTO_LOOP_DISABLED) {
      return false;
    }
    return DEFAULT_AUTO_LOOP;
  }
  #resolveIndex(index) {
    const count = this.#items.length;
    if (count === 0) {
      return INDEX_NONE;
    }
    if (!this.#autoLoop) {
      return index;
    }
    return (index % count + count) % count;
  }
}
registerElement(ELEMENT_NAME, ZygStory);
